import React, { Component } from "react";
import AutomationIcon from "@mui/icons-material/Assistant";
import {
  Box,
  Typography,
  TextField,
  Switch,
  FormControlLabel,
  Paper,
  Button,
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Divider,
  Alert,
  Stack,
  Avatar,
  CircularProgress,
  Container,
  CssBaseline,
  Checkbox,
  FormHelperText,
  Chip,
  FormLabel,
} from "@mui/material";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  ExpandMore as ExpandMoreIcon,
  Save as SaveIcon,
  AddRounded as AddRoundedIcon,
} from "@mui/icons-material";
import { withStyles } from "@mui/styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import Api from "../../services/api";
import { Styles } from "../../styles/material-styles";
import { connect } from "react-redux";
import Footer from "../../components/footer";
import HeaderMenu from "../../components/header-menu";
import CustomizedSnackbars from "../../components/material-snackbars";
import Title from "../../components/title-name";
import { browserHistory } from "../../helpers/history";
import { Overlay } from "../../styles/global";
import { PapiroConsole } from "../../utils/papiroConsole";
import EmailConfig from "src/components/emailConfig/EmailConfig";
import * as CalledService from "../../services/called.service";
import RealSimpleAutoComplete from "../../components/auto-complete/autocomplete-with-onclick";
import * as Service from "../../services/defaultaction.service";
import AddCommonPlaceholder from "src/components/emailConfig/AddCommonPlaceholder";
import SimpleAutoComplete from "../../components/auto-complete/autocomplete";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import Tooltip from "@mui/material/Tooltip";
import SimpleCheckBox from "../../components/checkbox/check";
import * as CalledOrganizationChecklistService from "../../services/calledorganizationchecklist.service";
import organization from "src/redux/reducers/organization";
import SimpleDatePicker from '../../components/date-pickers/inline';
import SimpleDatePickerHour from '../../components/date-pickers/inline-hour';
import SimpleAutoCompleteMultiple from "src/components/auto-complete/autocomplete-multiple";
import RegexInput from "src/components/regex-input/regex-input";
import { validateRegex } from "src/utils/macros/regex";

class AutomationEdit extends Component {
  constructor(props) {
    super(props);

    const automationDataToUpdate = props?.automations?.automation;
    const typeAutomation = automationDataToUpdate?.automationtypeid;

    console.log(automationDataToUpdate, "automationDataToUpdate");

    this.state = {
      nomeAutomacao: "",
      descricao: "",
      ativo: true,
      blocosFiltro: [],
      acoes: [
        {
          tipo: null,
          valor: null,
          body: `Olá {{ticket.requester.name}},

Informamos que seu chamado foi atualizado.

Status: {{ticket.status.name}}
Prioridade: {{ticket.priority.name}}
Técnico responsável: {{ticket.technical.name}}

Para mais detalhes, acesse: {{ticket.url}}

Atenciosamente,
{{hirer.name}}`,
          subject: "Chamado #{{ticket.id}} - {{ticket.title}}",
          requestingUserId: "",
          newCallTitle: "",
          newCallDescription: "",
          newCallProperties: "",
          setCategoryOrganizationValue: "",
          setCategoryOrganizationId: "",
        },
      ],
      eventos: {},
      typeAutomation: typeAutomation,
      actionsFields: [],
      actionFieldDetail: [],
      filtersFields: [],
      criteriaCondition: [],
      eventsActionOwner: [],
      fieldField: [],
      events: [],
      errors: {},
      tagValue: "",
      loading: false,
      openNotification: false,
      notificationVariant: "success",
      notificationMessage: "",
      automationDataToUpdate: automationDataToUpdate,
      organizationsFilterList: [],
      statusFilterList: [],
      typeFilterList: [],
      assignedUserFilterList: [],
      originFilterList: [],
      techinicalTeamFilterList: [],
      groupFilterList: [],
      priorityFilterList: [],
      categoriesFilterList: [],
      defaultactionFilterList: [],
      externalFormsFilterList: [],
      groupFilterList: [],
      segmentFilterList: [],

      hasDuplicates: false,

      loadingOrganizationFilter: false,
      loadingCategoryFilter: false,
      loadingStatusFilter: false,
      loadingTypeFilter: false,
      loadingAssignedUserFilter: false,
      loadingOriginFilter: false,
      loadingTechinicalTeamFilter: false,
      loadingPriorityFilter: false,
      loadingGroupTeamFilter: false,
      loadingGroupFilter: false,
      loadingSegmentFilter: false,
      loadingDefaultactionFilter: false,
      loadingExternalFormsFilter: false,
      filtersCalled: {
        organizationId: undefined,
      },
    };

    this.operadoresLogicos = this.getOperationLogic();
  }

  loadingFields = async () => {
    this.setState({ loading: true });

    await Promise.allSettled([
      this.getFilterPriority(),
      this.getFilterGroup(),
      this.getFilterStatus(),
      this.getFilterType(),
      this.getFilterAssignedUser(),
      this.getFilterOrigin(),
      this.getFilterTechinicalTeam(),
      this.getFilterOrganizations(),
      this.getFilterDefaultAction(),
      //this.getFilterCategoriesByOrganization(),
      this.getFilterExternalForms(),
      this.getFilterSegment(),
      this.getActionsFields(),
      this.getFiltersFields(),
      this.getCriteriaCondition(),
      this.getEventsActionOwner(),
    ]);

    setTimeout(() => {
      this.loadingInitialValues();
    }, 1000);
  };

  loadingInitialValues = async () => {
    const automationDataToUpdate = this.state.automationDataToUpdate;

    // TODO: Corrigir o id do Evento
    //EVENTOS - DATA
    const automationeventactionownerid =
      automationDataToUpdate.automationeventactionownerid || null;

    const _getEventsActionOwner = this.state.eventsActionOwner.filter(
      (ea) => ea?.eventownerid == automationeventactionownerid || null
    );

    const grupoData = await Promise.all(automationDataToUpdate?.automationeventdetails?.map(
      async (evts, index) => {
        const automationevent = evts?.automationevent || {};
        const actions = this.state.eventsActionOwner;

        const id = actions?.find((c) => {
          return (
            c?.eventid == automationevent?.id &&
            c?.eventownerid == automationeventactionownerid
          );
        })?.id;

        const tipo = `tipo_${id}_${automationevent?.name}`;
        var fromValue = evts?.automationeventcriterias?.[0]?.fromvalue;
        const toValue = evts?.automationeventcriterias?.[0]?.tovalue;

        if(automationevent?.name?.includes("Categoria foi atualizada")) {
          var result = await CalledService.getCategoryById(toValue);

          if(result.success) {
            const category = result.data;
            this.changeValuesPerFilter("organizationId", category.organization, "eventos", index);
            this.getFilterCategoriesByOrganization(category.organization, "eventos", index);
          }
        }

        if(automationevent?.name?.includes("O campo personalizado foi atualizado")){
          const organizationFieldId = toValue;
          var result = await CalledService.getOrganizationByOrgainizationFieldId(organizationFieldId);
          let organization = null;
          if (result.success) {
            organization = result.data?.organization;
            this.changeValuesPerFilter("organizationId", organization, "eventos", index);
            await this.getOrganizationFields(organization?.id);
          }
        }

        if (fromValue == null) {
          fromValue = "ANY";
        }

        return {
          tipo,
          valor: fromValue,
          de: fromValue,
          para: toValue,
        };
      }
    ));

    const updateEventosData = {
      acao: automationeventactionownerid,
      listAcoesDono: _getEventsActionOwner?.length ? _getEventsActionOwner : [],
      grupo: grupoData,
    };

    //FIM - EVENTOS - DATA

    //FILTROS - DATA

    const updateBlocosFiltro = await Promise.all(
      (automationDataToUpdate?.automationfilters ?? []).map(async (filtro) => {
        const automationconditions = filtro?.automationconditions;
        const firstAutomationcondition = automationconditions?.[0];

        const condicoes = await Promise.all(
          (filtro?.automationconditions ?? []).map(async (condicao, index) => {
            const automationconditioncriteriaid =
              condicao.automationconditioncriteriaid;

            const initialCriteriaCondition =
              this.state.criteriaCondition.filter(
                (c) => c?.conditioncriteriaid == automationconditioncriteriaid
              );

            const automationconditiontype = condicao.automationconditiontype;
            const campoValue = this.state?.fieldField?.find((c) => {
              return c?.field == automationconditiontype?.name;
            });

            const campovalueId = campoValue?.id;
            const campovaluefieldid = campoValue?.fieldid;

            const initialFilterFields = this.state.filtersFields.filter((f) => {
              return f?.fieldid == campovaluefieldid;
            });

            const campo = `campo_${campovalueId}`;
            const tipo = `tipo_${automationconditioncriteriaid}`;
            const operador = `operador_${condicao.automationoperatorid}`;

            const valor = condicao.automationconditionvalues?.[0]?.value || "";

            const filtersFields = initialFilterFields;
            const operatorList = initialCriteriaCondition;

            if (
              initialFilterFields.find((c) => c.conditioncriteriaid == 11) &&
              campovalueId != null
            ) {
              var result = await CalledService.getCategoryById(valor);
              if (result.success) {
                const category = result.data;
                this.changeValuesPerFilter("organizationId", category.organization, "valor", index);
                this.getFilterCategoriesByOrganization(category.organization, "valor", index);
              }
            }

            return {
              campo,
              tipo,
              operador,
              valor,
              filtersFields,
              operatorList,
            };
          })
        );

        const grupos = {
          id: firstAutomationcondition?.automationfilterid ?? null,
          operadorLogico: this.getOperationLogicById(
            firstAutomationcondition?.automationlogicaloperatorid
          ),
          condicoes,
        };

        return {
          id: filtro.automationid,
          operadorLogico: this.getOperationLogicById(
            filtro.automationlogicaloperatorid
          ),
          grupos: [grupos],
        };
      })
    );
    //FIM - FILTROS - DATA

    // //AÇÕES - DATA
    const updateActionsData = [];
    await Promise.all(
      automationDataToUpdate?.automationactiondetails?.map(async (ac, index) => {
        const actionmain = ac?.automationaction ?? {};
        const getName = actionmain?.name ?? null;
        const actiondatas = ac?.automationactiondetaildatas ?? {};

        if (getName == "Definir valor campo personalizado") {
          const organizationFieldId = actiondatas[0].organizationfieldid;
          var result = await CalledService.getOrganizationByOrgainizationFieldId(organizationFieldId);
          let organization = null;
          if (result.success) {
            organization = result.data?.organization;
            await this.getOrganizationFields(organization?.id);
          }
          
          updateActionsData.push({
            tipo: actiondatas[0]?.automationactionfieldid,
            organizationFieldId: actiondatas[0].organizationfieldid,
            organizationId: organization?.id,
            valor: actiondatas[0]?.value,
          });

          return;
        }

        if (this.fieldHasSetCategory(getName)) {
          const setCategoryConfigDataList = ac?.automationactiondetaildatas;
          const getActionSetCategoryContainValueId =
            this.state.actionFieldDetail?.find(
              (field) =>
                field?.name == getName &&
                field?.field == "apply_all_organizations_contain_value"
            )?.id;

          const getActionSetCategoryId = this.state.actionFieldDetail?.find(
            (field) =>
              field?.name == getName &&
              field?.field == "called.organization_caterory_id"
          )?.id;

          const setCategoryOrganizationValue =
            setCategoryConfigDataList?.find(
              (setCateg) =>
                setCateg?.automationactionfieldid ==
                getActionSetCategoryContainValueId
            )?.value ?? "";

          const setCategoryOrganizationId =
            setCategoryConfigDataList?.find(
              (setCateg) =>
                setCateg?.automationactionfieldid == getActionSetCategoryId
            )?.value ?? "";

          var result = await CalledService.getCategoryById(
            setCategoryOrganizationId
          );

          if (result.success) {
            const category = result.data;
            this.changeValuesPerFilter("organizationId", category.organization, "acao", index);
            this.getFilterCategoriesByOrganization(category.organization, "acao", index);
          }

          updateActionsData.push({
            tipo: getActionSetCategoryContainValueId ?? null,
            setCategoryOrganizationValue,
            setCategoryOrganizationId,
          });
          return;
        }

        if (this.fieldHasNewCall(getName)) {
          const newCallConfigDataList = ac?.automationactiondetaildatas;

          const getActionNewCallCalledTitleId =
            this.state.actionFieldDetail?.find(
              (field) =>
                field?.name == getName && field?.field == "called.title"
            )?.id;
          const getActionNewCallCalledDescriptionId =
            this.state.actionFieldDetail?.find(
              (field) =>
                field?.name == getName && field?.field == "called.description"
            )?.id;
          const getActionNewCallCalledExistingId =
            this.state.actionFieldDetail?.find(
              (field) =>
                field?.name == getName &&
                field?.field == "inherit_existing_properties"
            )?.id;

          const getActionNewCallCalledOrganization =
            this.state.actionFieldDetail?.find(
              (field) =>
                field?.name === getName &&
                field?.field === "called.organization_id"
            )?.id;

          const newCallTitle =
            newCallConfigDataList?.find(
              (setCateg) =>
                setCateg?.automationactionfieldid ==
                getActionNewCallCalledTitleId
            )?.value ?? "";

          const newCallDescription =
            newCallConfigDataList?.find(
              (setCateg) =>
                setCateg?.automationactionfieldid ==
                getActionNewCallCalledDescriptionId
            )?.value ?? "";

          const newCallProperties =
            newCallConfigDataList?.find(
              (setCateg) =>
                setCateg?.automationactionfieldid ==
                getActionNewCallCalledExistingId
            )?.value ?? "";

          const newCallOrganizationId =
            newCallConfigDataList?.find(
              (setCateg) =>
                setCateg?.automationactionfieldid ==
                getActionNewCallCalledOrganization
            )?.value ?? "";

          updateActionsData.push({
            tipo: 23 ?? null,
            newCallTitle,
            newCallDescription,
            newCallProperties,
            newCallOrganizationId,
          });
          return;
        }

        if (this.fieldHasEmailConfig(getName)) {
          const emailConfigDataList = ac?.automationactiondetaildatas;

          const getActionEmailBodyId = this.state.actionFieldDetail?.find(
            (field) => field?.name == getName && field?.field == "email.body"
          )?.id;

          const getActionEmailSubjectId = this.state.actionFieldDetail?.find(
            (field) => field?.name == getName && field?.field == "email.subject"
          )?.id;

          const getActionRequestingUserId = this.state.actionFieldDetail?.find(
            (field) =>
              field?.name == getName &&
              field?.field == "called.assigned_user_id"
          )?.id;

          const body =
            emailConfigDataList?.find(
              (emconf) =>
                emconf?.automationactionfieldid == getActionEmailBodyId
            )?.value ?? "";

          const subject =
            emailConfigDataList?.find(
              (emconf) =>
                emconf?.automationactionfieldid == getActionEmailSubjectId
            )?.value ?? "";

          const requestingUserId =
            emailConfigDataList?.find(
              (emconf) =>
                emconf?.automationactionfieldid == getActionRequestingUserId
            ) ?? "";
            
            const actionsFieldsUpdateId = this.state.actionsFields?.find(
              (field) => field?.name === ac?.automationaction?.name
            );

          updateActionsData.push({
            tipo:actionsFieldsUpdateId?.id ?? null,
            valor: requestingUserId?.value ?? "",
            body,
            subject,
            requestingUserId: requestingUserId?.value ?? null,
          });
          return;
        }

        actiondatas.map((data) => {
          updateActionsData.push({
            tipo: data?.automationactionfieldid ?? null,
            //organizationFieldId: data?.organizationFieldId ?? null,
            valor: data?.value ?? "",
          });
        });
      })
    );
    //FIM - AÇÕES - DATA

    this.setState({
      nomeAutomacao: automationDataToUpdate?.name || "",
      descricao: automationDataToUpdate?.description || "",
      ativo: automationDataToUpdate?.active,
      eventos: updateEventosData,
      blocosFiltro: updateBlocosFiltro,
      acoes: updateActionsData,
      loading: false,
    });
  };

  //Carregamento dos campos select
  showMessageIfDontHaveData = () => {
    this.setState({
      openNotification: true,
      notificationVariant: "warning",
      notificationMessage: "Não existem dados para esse campo",
    });
  };

  getFilterExternalForms = async () => {
    if(this.state.externalFormsFilterList.length > 0 || this.state.loadingExternalFormsFilter) {
        return;
    }

    this.setState({ loadingExternalFormsFilter: true });

    try {
        const result = await CalledService.getExternalForms();
        if (result.success) {
            this.setState({ externalFormsFilterList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.title.localeCompare(b.title)) : result.data });

            if(result.data?.length == 0){
                this.showMessageIfDontHaveData();
            }
        } else {
            const intl = this.props.intl;
            this.setState({
                openNotification: true, notificationVariant: "error",
                notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(result);
        }
    } catch(err) {
        const intl = this.props.intl;
        this.setState({
          loading: false, 
          openNotification: true, 
          notificationVariant: "error",
          notificationMessage: intl.formatMessage({ id: "process.error" })
        });
    }
    

    this.setState({ loadingExternalFormsFilter: false });
  }

  getFilterDefaultAction = async () => {
    if (
      this.state.defaultactionFilterList.length > 0 ||
      this.state.loadingDefaultactionFilter
    ) {
      return;
    }

    this.setState({ loadingDefaultactionFilter: true });

    try {
      const result = await Service.getAll();
      if (result.success) {
        this.setState({ defaultactionFilterList: result.data });
        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
            result.response.data &&
            result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingDefaultactionFilter: false });
  };

  getFilterCategoriesByOrganization = async (organization, evento, index) => {
    // organization pode vir como objeto {id} ou como número
    const organizationId = typeof organization === 'object'
      ? (organization?.id ?? organization?.value ?? null)
      : organization;

    // Guards iniciais
    if (!organizationId) return;
    if (this.state.loadingCategoryFilter) return;

    const existing =
      this.state.categoriesFilterList?.[evento]?.[index];

    // Se já tem dados carregados para esse slot, não recarrega
    if (Array.isArray(existing) && existing.length > 0) return;

    this.setState({ loadingCategoryFilter: true });

    try {
      const res = await CalledService.getCategoriesByOrganizationDapper(organizationId);

      const finalResult = Array.isArray(res?.data)
        ? [...res.data].sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''))
        : [];

      if (finalResult.length === 0) {
        this.showMessageIfDontHaveData?.();
      }

      // Atualização IMUTÁVEL por níveis
      this.setState(prev => {
        const categoriesFilterList = { ...prev.categoriesFilterList };
        const eventoObj = { ...(categoriesFilterList[evento] ?? {}) };
        eventoObj[index] = finalResult;
        categoriesFilterList[evento] = eventoObj;

        return {
          categoriesFilterList,
          loadingCategoryFilter: false,
        };
      });
    } catch (err) {
      const { intl } = this.props;
      this.setState({
        loadingCategoryFilter: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }
  };

  getFilterGroup = async () => {
    if (
      this.state.groupFilterList.length > 0 ||
      this.state.loadingGroupFilter
    ) {
      return;
    }

    this.setState({ loadingGroupFilter: true });

    try {
      const result = await CalledService.getGroups();
      if (result.success) {
        this.setState({
          groupFilterList:
            result.data && result.data.length > 1
              ? result.data.sort((a, b) => a.name.localeCompare(b.name))
              : result.data,
        });

        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
            result.response.data &&
            result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingGroupFilter: false });
  };

  getFilterSegment = async () => {
    if (
      this.state.segmentFilterList.length > 0 ||
      this.state.loadingSegmentFilter
    ) {
      return;
    }

    this.setState({ loadingSegmentFilter: true });

    try {
      const result = await CalledService.getSegment();
      if (result.success) {
        this.setState({
          segmentFilterList:
            result.data && result.data.length > 1
              ? result.data.sort((a, b) => a.name.localeCompare(b.name))
              : result.data,
        });

        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
            result.response.data &&
            result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingSegmentFilter: false });
  };

  getFilterPriority = async () => {
    if (
      this.state.priorityFilterList.length > 0 ||
      this.state.loadingPriorityFilter
    ) {
      return;
    }

    this.setState({ loadingPriorityFilter: true });

    try {
      const result = await CalledService.getPriority();
      if (result.success) {
        this.setState({ priorityFilterList: result.data });
        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
            result.response.data &&
            result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingPriorityFilter: false });
  };

  getFilterStatus = async () => {
    if (
      this.state.statusFilterList.length > 0 ||
      this.state.loadingStatusFilter
    ) {
      return;
    }

    this.setState({ loadingStatusFilter: true });

    try {
      const result = await CalledService.getStatusDapper();
      if (result.success) {
        this.setState({
          statusFilterList:
            result.data && result.data.length > 1
              ? result.data.sort((a, b) => a.name.localeCompare(b.name))
              : result.data,
        });
        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
            result.response.data &&
            result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingStatusFilter: false });
  };

  getFilterType = async () => {
    if (this.state.typeFilterList.length > 0 || this.state.loadingTypeFilter) {
      return;
    }

    this.setState({ loadingTypeFilter: true });

    try {
      const result = await CalledService.getTypesDapper();
      if (result.success) {
        this.setState({
          typeFilterList:
            result.data && result.data.length > 1
              ? result.data.sort((a, b) => a.name.localeCompare(b.name))
              : result.data,
        });
        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
            result.response.data &&
            result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingTypeFilter: false });
  };

  getFilterAssignedUser = async () => {
    if (
      this.state.assignedUserFilterList.length > 0 ||
      this.state.loadingAssignedUserFilter
    ) {
      return;
    }

    this.setState({ loadingAssignedUserFilter: true });

    try {
      const result = await CalledService.getTechinicalUsersDapper();
      if (result.success) {
        this.setState({
          assignedUserFilterList:
            result.data && result.data.length > 1
              ? result.data.sort((a, b) => a.name.localeCompare(b.name))
              : result.data,
        });

        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
            result.response.data &&
            result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingAssignedUserFilter: false });
  };

  getFilterOrigin = async () => {
    if (
      this.state.originFilterList.length > 0 ||
      this.state.loadingOriginFilter
    ) {
      return;
    }

    this.setState({ loadingOriginFilter: true });

    try {
      const result = await CalledService.getOriginRequestsDapper();
      if (result.success) {
        this.setState({
          originFilterList:
            result.data && result.data.length > 1
              ? result.data.sort((a, b) => a.name.localeCompare(b.name))
              : result.data,
        });

        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
            result.response.data &&
            result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingOriginFilter: false });
  };

  getFilterTechinicalTeam = async () => {
    if (
      this.state.techinicalTeamFilterList.length > 0 ||
      this.state.loadingTechinicalTeamFilter
    ) {
      return;
    }

    this.setState({ loadingTechinicalTeamFilter: true });

    try {
      const result = await CalledService.getFilterTechinicalTeamDapper();
      if (result.success) {
        this.setState({
          techinicalTeamFilterList:
            result.data && result.data.length > 1
              ? result.data.sort((a, b) => a.name.localeCompare(b.name))
              : result.data,
        });

        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
            result.response.data &&
            result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingTechinicalTeamFilter: false });
  };

  getFilterOrganizations = async () => {
    if (
      this.state.organizationsFilterList.length > 0 ||
      this.state.loadingOrganizationFilter
    ) {
      return;
    }

    this.setState({ loadingOrganizationFilter: true });

    const { userSession } = this.props;

    let orgData = [];

    if (
      userSession &&
      userSession.user &&
      userSession.user.userorganizations &&
      userSession.user.userorganizations.length > 0
    ) {
      orgData = userSession.user.userorganizations;
      const result = await CalledService.getOrganizationsDapper();
      if (result.success) {
        orgData = result.data;

        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
            result.response.data &&
            result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    }

    if (orgData != null) {
      orgData = orgData.filter((c) => c.active == true);
      this.setState({
        locationFilterList: [],
        categoriesFilterList: [],
        deptFilterList: [],
        customOrganizationFilterFields: [],
        customOrganizationFilterFieldsValues: [],
        customOrganizationFilterFieldsList: [],
        organizationsFilterList:
          orgData && orgData.length > 1
            ? orgData.sort((a, b) => a.name.localeCompare(b.name))
            : orgData,
      });
    } else {
      orgData = [];
      this.setState({
        organizationsFilterList:
          orgData && orgData.length > 1
            ? orgData.sort((a, b) => a.name.localeCompare(b.name))
            : orgData,
      });
    }

    this.setState({ loadingOrganizationFilter: false });
  };

  componentWillReceiveProps(nextProps) {}

  //Bloco de ações
  //Bloco de carregamento das ações
  getActionsFields = async () => {
    let url = `/automation/action-fields/2`;
    Api.get(url)
      .then((result) => {
        if (result.data.success) {
          
          const data = result.data.data.filter(
            (item) =>
              item.name !== "Atribuir obsevador"
          );

          const uniqueByName = data.filter(
            (item, index, self) =>
              index == self.findIndex((t) => t.name == item.name)
          );
          this.setState({
            actionsFields: uniqueByName,
            actionFieldDetail: data,
          });
        } else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data &&
              result.data.response &&
              result.data.response.data &&
              result.data.response.data.errors &&
              result.data.response.data.errors[0]
                ? result.data.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
          Api.kickoff(result);
        }
      })
      .catch((err) => {
        const intl = this.props.intl;
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            err.response &&
            err.response.data &&
            err.response.data.errors &&
            err.response.data.errors[0]
              ? err.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(err);
      });
  };

  //Bloco de carregamento dos filtros
  getFiltersFields = async () => {
    let url = `/automation/filter-fields/${this.state.typeAutomation}`;
    return Api.get(url)
      .then((result) => {
        if (result.data.success) {
          const data = result.data.data;
          const seen = new Set();
          const uniqueFields = data
            .filter((item) => {
              const key = `${item.field}-${item.fieldid}`;
              if (seen.has(key)) {
                return false;
              }
              seen.add(key);
              return true;
            })
            .map((item) => ({
              field: item.field,
              fieldid: item.fieldid,
              id: item.id,
            }));

          this.setState({ filtersFields: data, fieldField: uniqueFields });
        } else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data &&
              result.data.response &&
              result.data.response.data &&
              result.data.response.data.errors &&
              result.data.response.data.errors[0]
                ? result.data.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
          Api.kickoff(result);
        }
      })
      .catch((err) => {
        const intl = this.props.intl;
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            err.response &&
            err.response.data &&
            err.response.data.errors &&
            err.response.data.errors[0]
              ? err.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(err);
      });
  };

  async getOrganizationFields(organizationId) {
    try {
      var finalResult = [];
      const result =
        await CalledOrganizationChecklistService.getActiveOrganizationFieldsByOrganizationAndCategories(
          organizationId
        );
      if (result.success) {
        finalResult = result.data;
      }
      this.setState({ customOrganizationFilterFields: finalResult });
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }
  }

  returnFields(id, index, valor) {
      const campoTexto = [];
      const arrayselecao = [];
      const element = this.state.customOrganizationFilterFields.find(
        (item) => item.id == id
      ) || {};
      const fieldType = element?.organizationfieldtype;
  
      if (element.organizationfieldoptionsvalues?.length > 0) {
        element.organizationfieldoptionsvalues.forEach((element2) => {
          if (fieldType == 2 || fieldType == 4 || fieldType == 6) {
            arrayselecao.push(element2);
          }
        });
  
        if (fieldType == 2) {
          campoTexto.push(
            <Grid item xs={12}>
              <FormControl required={element.isrequired}>
                <FormLabel id="demo-radio-buttons-group-label">
                  {element.name}
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                >
                  {arrayselecao.map((item) => (
                    <FormControlLabel
                      name={"ofield-" + element.id}
                      value={item.name + "\n" + item.id}
                      stateName={"ofield-" + element.name}
                      onChange={(e) => {
                        this.atualizarAcao(index, "valor", item.id)
                      }}
                      control={<Radio />}
                      label={item.name}
                      checked={valor == item.id}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Grid>
          );
        }
  
        if (fieldType == 4) {
          campoTexto.push(
            <Grid item xs={6}>
              <SimpleAutoComplete
                selected={valor}
                label={element.name}
                options={arrayselecao}
                stateName={"ofield-" + element.id}
                changeSelect={(stateName, value) => {
                  this.atualizarAcao(index, "valor", value)
                }}
              />
            </Grid>
          );
        }

        if (fieldType == 6) {
          const selectedValues = valor && arrayselecao.length > 0 && arrayselecao?.filter((field) => valor?.includes(field?.id)) || [];

          campoTexto.push(
            <Grid item xs={6}>
              <SimpleAutoCompleteMultiple
                selected={selectedValues}
                label={element.name}
                options={arrayselecao}
                stateName={"ofield-" + element.id}
                changeSelect={(stateName, value) => {
                  const valueIds = value?.map(v => v.id).join(",") || [];

                  const novasAcoes = [...this.state.acoes];
                  novasAcoes[index]["valor"] = valueIds;
                  this.setState({ acoes: novasAcoes });
                }}
              />

              {this.state.errors.acoes?.[index]?.valor && (
                <FormHelperText error>
                  {this.state.errors.acoes?.[index]?.valor}
                </FormHelperText>
              )}
            </Grid>
          );
        }
      }
  
      if (fieldType == 1) {
        campoTexto.push(
          <Grid item xs={6}>
            <TextField
              autoComplete="fname"
              name={"ofield-" + element.id}
              variant="outlined"
              id={"ofield-" + element.id}
              label={element.name}
              fullWidth
              onChange={(e) => {
                this.atualizarAcao(index, "valor", e.target.value);
              }}
              inputProps={{
                maxLength: element.maxlength ? element.maxlength : 250,
              }}
              value={valor}
            />
          </Grid>
        );
      }
  
      if (fieldType == 3) {
        campoTexto.push(
          <Grid item xs={12}  >
            <SimpleCheckBox
              selected={this.state[`ofield-${element.id}`] === "true"}
              label={element.name}
              name={"ofield-" + element.id}
              stateName={"ofield-" + element.id}
              changeSelect={(stateName, value) => {
                this.atualizarAcao(index, "valor", value);
              }}
              selectedValue={valor === "true" ? true : false}
            />
          </Grid>
        );
      }

    if (fieldType == 5) {
      campoTexto.push(
        <Grid item xs={6}>
          <TextField
            value={valor}
            type="number"
            autoComplete="fname"
            name={"ofield-" + element.id}
            variant="outlined"
            id={"ofield-" + element.id}
            label={element.name}
            fullWidth
            onChange={(e) => {
              this.atualizarAcao(index, "valor", e.target.value);
            }}
            inputProps={{
              min: 0
            }}
          />
        </Grid>
      );
    }

    if (fieldType == 7) {
      campoTexto.push(
        <Grid item xs={12}>
          <TextField
            value={valor}
            autoComplete="fname"
            name={"ofield-" + element.id}
            variant="outlined"
            id={"ofield-" + element.id}
            label={element.name}
            fullWidth
            multiline
            rows={element.maxlength}
            onChange={(e) => {
              this.atualizarAcao(index, "valor", e.target.value);
            }}
          />
        </Grid>
      );
    }

    if (fieldType == 8) {
      campoTexto.push(
        <Grid item xs={6}>
          <TextField
            value={valor}
            type="number"
            autoComplete="fname"
            name={"ofield-" + element.id}
            variant="outlined"
            id={"ofield-" + element.id}
            label={element.name}
            fullWidth
            onChange={(e) => {
              this.atualizarAcao(index, "valor", e.target.value);
            }}
            inputProps={{
              step: '0.01',
              min: 0
            }}
          />
        </Grid>
      );
    }

    if (fieldType == 9) {
      campoTexto.push(
        <Grid item xs={6}>
          <SimpleDatePickerHour
            currentDate={valor}
            label={element.name}
            stateName={"ofield-" + element.id}
            changeDate={(stateName, date) => {
              this.atualizarAcao(index, "valor", date)
            }}
          />
        </Grid>
      );
    }

    if (fieldType == 10) {
      const regex = element.organizationfieldoptionsvalues.length > 0 ? element.organizationfieldoptionsvalues[0].name : '';

      campoTexto.push(
        <Grid item xs={12}>
          <RegexInput
            defaultValue={valor}
            id={"ofield-" + element.id}
            name={"ofield-" + element.id}
            label={element.name}
            regex={regex}
            hasError={!!this.state?.errors?.acoes?.[index]?.valor}
            errorMessage={this.state?.errors?.acoes?.[index]?.valor}
            onChangeValue={(e) => {
              this.atualizarAcao(index, "valor", e.target.value);
            }}
          />
        </Grid>
      );
    }
  
    return campoTexto;
  }

  getCriteriaCondition = async () => {
    let url = `/automation/filter-fields-operator`;
    return Api.get(url)
      .then((result) => {
        if (result.data.success) {
          this.setState({ criteriaCondition: result.data.data });
        } else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data &&
              result.data.response &&
              result.data.response.data &&
              result.data.response.data.errors &&
              result.data.response.data.errors[0]
                ? result.data.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
          Api.kickoff(result);
        }
      })
      .catch((err) => {
        const intl = this.props.intl;
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            err.response &&
            err.response.data &&
            err.response.data.errors &&
            err.response.data.errors[0]
              ? err.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(err);
      });
  };

  //Operadores do bloco de filtros

  //Carrega os valores dos radions apenas quand for atualização de ticket no bloco de eventos
  getEventsActionOwner = async () => {
    let url = `/automation/event-fields`;
    return Api.get(url)
      .then((result) => {
        if (result.data.success) {
          const eventsActionOwner = result.data.data.filter(
            (item) =>
              !item.eventname.includes("Observador foi adicionado") &&
              !item.eventname.includes("Localização foi atualizada")
          );
          const events = eventsActionOwner
            .filter(
              (item, index, self) =>
                index == self.findIndex((t) => t.ownername == item.ownername)
            )
            .map((item) => ({
              id: item.eventownerid,
              name: item.ownername,
            }));
          console.log(eventsActionOwner, 'eventsActionOwner');
          console.log(events, 'events');
          this.setState({
            eventsActionOwner: eventsActionOwner,
            events: events,
          });
        } else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data &&
              result.data.response &&
              result.data.response.data &&
              result.data.response.data.errors &&
              result.data.response.data.errors[0]
                ? result.data.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
          Api.kickoff(result);
        }
      })
      .catch((err) => {
        const intl = this.props.intl;
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            err.response &&
            err.response.data &&
            err.response.data.errors &&
            err.response.data.errors[0]
              ? err.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(err);
      });
  };

  getOperationLogic() {
    const { intl } = this.props
    return [
      { id: 1, name: intl.formatMessage({ id: "and" }) },
      { id: 2, name: intl.formatMessage({ id: "or" }) },
    ];
  }

  getOperationLogicById(id) {
    const operationLogic = this.getOperationLogic();
    return operationLogic.find((logic) => logic.id == id) || null;
  }

  async componentDidMount() {
    this.loadingFields();
  }
  // Handlers para campos básicos
  handleNomeChange = (e) => {
    this.setState({ nomeAutomacao: e.target.value });
  };

  handleDescricaoChange = (e) => {
    this.setState({ descricao: e.target.value });
  };

  handleAtivoChange = () => {
    this.setState((prevState) => ({ ativo: !prevState.ativo }));
  };

  // Função para adicionar um novo bloco de filtro
  adicionarBlocoFiltro = () => {
    const novosBloco = [...this.state.blocosFiltro];
    const novoId = Math.max(...novosBloco.map((bloco) => bloco.id), 0) + 1;

    const persistirOperadorLogico = novosBloco[0]?.operadorLogico;

    novosBloco.push({
      id: novoId,
      operadorLogico: persistirOperadorLogico,
      grupos: [
        {
          id: 1,
          operadorLogico: this.operadoresLogicos[0],
          condicoes: [
            {
              tipo: null,
              campo: null,
              operador: null,
              valor: null,
              fieldsList: [],
              operatorList: [],
            },
          ],
        },
      ],
    });

    this.setState({ blocosFiltro: novosBloco });
  };

  // Função para remover um bloco de filtro
  removerBlocoFiltro = (blocoId) => {
    const novosBloco = this.state.blocosFiltro.filter(
      (bloco) => bloco.id !== blocoId
    );
    this.setState({ blocosFiltro: novosBloco });
  };

  // Função para adicionar um novo grupo dentro de um bloco
  adicionarGrupo = (blocoId) => {
    const novosBloco = [...this.state.blocosFiltro];
    const blocoIndex = novosBloco.findIndex((bloco) => bloco.id == blocoId);

    if (blocoIndex !== -1) {
      const novoId =
        Math.max(...novosBloco[blocoIndex].grupos.map((grupo) => grupo.id), 0) +
        1;

      novosBloco[blocoIndex].grupos.push({
        id: novoId,
        operadorLogico: this.operadoresLogicos[0],
        condicoes: [
          {
            tipo: null,
            campo: null,
            operador: null,
            valor: null,
            fieldsList: [],
            operatorList: [],
          },
        ],
      });

      this.setState({ blocosFiltro: novosBloco });
    }
  };

  // Função para remover um grupo
  removerGrupo = (blocoId, grupoId) => {
    const novosBloco = [...this.state.blocosFiltro];
    const blocoIndex = novosBloco.findIndex((bloco) => bloco.id == blocoId);

    if (blocoIndex !== -1) {
      novosBloco[blocoIndex].grupos = novosBloco[blocoIndex].grupos.filter(
        (grupo) => grupo.id !== grupoId
      );
      if (novosBloco[blocoIndex].grupos.length == 0) {
        novosBloco.splice(blocoIndex, 1);
      }
      this.setState({ blocosFiltro: novosBloco });
    }
  };

  // Função para atualizar o operador lógico entre blocos
  atualizarOperadorBloco = (blocoId, novoOperador) => {
    const novosBloco = [...this.state.blocosFiltro];
    const blocoIndex = novosBloco.findIndex((bloco) => bloco.id == blocoId);

    const _novoOperador = this.operadoresLogicos?.find(
      (op) => op?.id == novoOperador
    );

    if (blocoIndex !== -1) {
      const novosBlocoAtualizadoComOperador = novosBloco.map((bloco) => {
        return {
          ...bloco,
          operadorLogico: _novoOperador,
        };
      });

      this.setState({ blocosFiltro: novosBlocoAtualizadoComOperador });
    }
  };

  // Função para atualizar o operador lógico dentro de um grupo
  atualizarOperadorGrupo = (blocoId, grupoId, novoOperador) => {
    const novosBloco = [...this.state.blocosFiltro];
    const blocoIndex = novosBloco.findIndex((bloco) => bloco.id == blocoId);

    const _novoOperador = this.operadoresLogicos?.find(
      (op) => op?.id == novoOperador
    );

    if (blocoIndex !== -1) {
      const grupoIndex = novosBloco[blocoIndex].grupos.findIndex(
        (grupo) => grupo.id == grupoId
      );

      if (grupoIndex !== -1) {
        novosBloco[blocoIndex].grupos[grupoIndex].operadorLogico =
          _novoOperador;
        this.setState({ blocosFiltro: novosBloco });
      }
    }
  };

  // Função para adicionar condição a um grupo
  adicionarCondicao = (blocoId, grupoId) => {
    const novosBloco = [...this.state.blocosFiltro];
    const blocoIndex = novosBloco.findIndex((bloco) => bloco.id == blocoId);

    if (blocoIndex !== -1) {
      const grupoIndex = novosBloco[blocoIndex].grupos.findIndex(
        (grupo) => grupo.id == grupoId
      );
      if (grupoIndex !== -1) {
        novosBloco[blocoIndex].grupos[grupoIndex].condicoes.push({
          tipo: null,
          campo: null,
          operador: null,
          valor: null,
          fieldsList: [],
          operatorList: [],
        });
        this.setState({ blocosFiltro: novosBloco });
      }
    }
  };

  // Função para remover condição de um grupo
  removerCondicao = (blocoId, grupoId, condicaoIndex) => {
    const novosBloco = [...this.state.blocosFiltro];
    const blocoIndex = novosBloco.findIndex((bloco) => bloco.id == blocoId);

    if (blocoIndex !== -1) {
      const grupoIndex = novosBloco[blocoIndex].grupos.findIndex(
        (grupo) => grupo.id == grupoId
      );
      if (grupoIndex !== -1) {
        if (novosBloco[blocoIndex].grupos[grupoIndex].condicoes.length > 1) {
          novosBloco[blocoIndex].grupos[grupoIndex].condicoes.splice(
            condicaoIndex,
            1
          );
        } else if (novosBloco[blocoIndex].grupos.length > 1) {
          // Se for a última condição do grupo e houver mais de um grupo, remover o grupo
          novosBloco[blocoIndex].grupos.splice(grupoIndex, 1);
        } else if (this.state.blocosFiltro.length > 1) {
          // Se for o último grupo do bloco e houver mais de um bloco, remover o bloco
          novosBloco.splice(blocoIndex, 1);
        }
        this.setState({ blocosFiltro: novosBloco });
      }
    }
  };

  getFieldidByCampoId = (campoId) => {
    const field = this.state.fieldField.find((f) => f.id == campoId);
    return field ? field?.fieldid : null;
  };

  // Função para atualizar uma condição
  atualizarCondicao = (blocoId, grupoId, condicaoIndex, campo, valor) => {
    const novosBloco = [...this.state.blocosFiltro];
    const blocoIndex = novosBloco.findIndex((bloco) => bloco.id == blocoId);

    const isType = campo === "tipo";
    const isField = campo === "campo";
    const isOperador = campo === "operador";
    const isValor = campo === "valor";

    const filtersByType = this.state.filtersFields;
    const criteriaCondition = this.state.criteriaCondition;

    if (blocoIndex !== -1) {
      const grupoIndex = novosBloco[blocoIndex].grupos.findIndex(
        (grupo) => grupo.id == grupoId
      );

      if (grupoIndex !== -1) {
        const condicao = novosBloco[blocoIndex].grupos[grupoIndex].condicoes[condicaoIndex];

        novosBloco[blocoIndex].grupos[grupoIndex].condicoes[condicaoIndex][
          campo
        ] = valor;

        if (isField) {
          const fieldid = this.getFieldidByCampoId(
            valor?.split("_")?.[1] ?? null
          );

          const newFiltersFields = filtersByType.filter(
            (f) => f?.fieldid == fieldid
          );

          novosBloco[blocoIndex].grupos[grupoIndex].condicoes[
            condicaoIndex
          ].filtersFields = newFiltersFields;
        }

        if (isType) {
          const conditionCriteriaIdByValue = valor?.split("_")?.[1] ?? null;

          const newOperatorList = criteriaCondition.filter(
            (c) => c?.conditioncriteriaid == conditionCriteriaIdByValue
          );

          novosBloco[blocoIndex].grupos[grupoIndex].condicoes[
            condicaoIndex
          ].operatorList = newOperatorList;
          
           if(!this.filtroCampoQueNaoPrecisaDoValor(condicao)){
             novosBloco[blocoIndex].grupos[grupoIndex].condicoes[
               condicaoIndex
              ].operador = null;

             novosBloco[blocoIndex].grupos[grupoIndex].condicoes[
               condicaoIndex
              ].valor = null;

           }
        }
        
        if(isOperador) {
          if(this.filtroCampoQueNaoPrecisaDoValor(condicao)){
            const isOperatorWithValue = ["Está"];
            const conditionCriteriaIdByValue = valor?.split("_")?.[1] ?? null;

            const selectedOperator = condicao.operatorList.find(
              (c) => c?.id == conditionCriteriaIdByValue
            );

            const isOperatorWithValueSelected = isOperatorWithValue.some(
              (op) => op == selectedOperator.name
            );

            novosBloco[blocoIndex].grupos[grupoIndex].condicoes[
              condicaoIndex
            ].valor = isOperatorWithValueSelected ? "true" : "false";
          }
        }

        if(isType || isField || isOperador || isValor) {
          const arr = novosBloco[blocoIndex].grupos[grupoIndex].condicoes;

          let errors = {...this.state.errors};
          
          if(this.hasDuplicates(arr, "campo,tipo,operador,valor")){
            if (!errors.blocosFiltro) {
              errors.blocosFiltro = {};
            }

            if (!errors.blocosFiltro[blocoIndex]) {
              errors.blocosFiltro[blocoIndex] = {};
            }

            errors.blocosFiltro[blocoIndex][grupoIndex] = {
              ...errors.blocosFiltro[blocoIndex][grupoIndex],
              hasDuplicateFilter: "Não é possível adicionar o mesmo filtro mais de uma vez.*"
            }

            this.setState({ errors });
          }else{
            if (!errors.blocosFiltro) {
              errors.blocosFiltro = {};
            }

            if (!errors.blocosFiltro[blocoIndex]) {
              errors.blocosFiltro[blocoIndex] = {};
            }

            errors.blocosFiltro[blocoIndex][grupoIndex] = {
              ...errors.blocosFiltro[blocoIndex][grupoIndex],
              hasDuplicateFilter: null
            }

            this.setState({ errors });
          }
        }

        this.setState({ blocosFiltro: novosBloco });
      }
    }
  };

  adicionarEvento = () => {
    const novasEventos = { ...this.state.eventos };

    novasEventos?.grupo?.push({
      tipo: null,
      valor: null,
      de: null,
      para: null,
    });

    this.setState({ eventos: novasEventos });
  };

  adicionarAcao = () => {
    this.setState((prevState) => ({
      acoes: [...prevState.acoes, { tipo: null, valor: null }],
    }));
  };

  removerEvento = (index) => {
    const novasEventos = { ...this.state.eventos };

    novasEventos.grupo = novasEventos.grupo
      .slice(0, index)
      .concat(novasEventos?.grupo?.slice(index + 1));

    this.setState({ eventos: novasEventos });
  };

  removerAcao = (index) => {
    const novasAcoes = [...this.state.acoes];
    novasAcoes.splice(index, 1);
    this.setState({ acoes: novasAcoes });
  };

  atualizarEvento = (groupIndex, campo, valor) => {
    const novasEventos = { ...this.state.eventos };

    const isAcaoType = campo == "acao";

    if (isAcaoType) {
      novasEventos[campo] = valor;

      const newlistAcoesDono = this.state.eventsActionOwner.filter(
        (ea) => ea?.eventownerid == valor
      );

      novasEventos.listAcoesDono = newlistAcoesDono;

      this.setState({ eventos: novasEventos });
      return;
    }

    novasEventos.grupo[groupIndex][campo] = valor;
     
    const isEventoQueNaoPrecisaDoCampoValor = this.eventosQueNaoPrecisaDoCampoValor(groupIndex);

    if (campo === "tipo" && isEventoQueNaoPrecisaDoCampoValor) {
      novasEventos.grupo[groupIndex].valor = "true";
    }else{
      novasEventos.grupo[groupIndex].valor = null;
    }


    this.setState({ eventos: novasEventos });
  };

  
  handleDeleteTagFilterTag(tagToDelete, value, blocoId, grupoId, condicaoIndex) {
    const oldValueTags = value?.split(",")?.filter((ac) => ac) ?? [];

    const newTags = oldValueTags.filter((tag) => tag !== tagToDelete).join(',');
    
    this.atualizarCondicao(
      blocoId,
      grupoId,
      condicaoIndex,
      "valor",
      newTags
    )
  }

  handleFilterTagInputKeyDown(event, condicao, blocoId, grupoId, condicaoIndex) {
    const newValue = condicao?.inputFilterTagValue?.trim();

    if (event.key === "Enter" && newValue) {
      const oldValue = condicao?.valor ?? "";

      if (newValue == ""){
        event.preventDefault();
        return;
      };

      const oldValueTags = oldValue?.split(",")?.filter((ac) => ac) ?? []
      
      if (oldValueTags.some((tag) => tag.toLowerCase() === (newValue.trim()).toLowerCase())){
        this.atualizarCondicao(
          blocoId,
          grupoId,
          condicaoIndex,
          "inputFilterTagValue",
          ""
        )

        event.preventDefault();
        return;
      } 

      const newTagValue =
        oldValue == "" || !oldValue ? (newValue.trim()) : oldValue + "," + (newValue.trim());

        this.atualizarCondicao(
          blocoId,
          grupoId,
          condicaoIndex,
          "valor",
          newTagValue
        )

      this.atualizarCondicao(
          blocoId,
          grupoId,
          condicaoIndex,
          "inputFilterTagValue",
          ""
        )
      
      event.preventDefault();
    }
  }

  handleOnBlurAddValues(e, bloco, grupo, condicaoIndex) {
    const newValue = e.target.value;

    if (!newValue.trim()) {
      e.preventDefault();
      return;
    };

    const oldValue = grupo.condicoes[condicaoIndex]?.valor ?? "";

    const oldValueTags = oldValue?.split(",")?.filter((ac) => ac) ?? []

    if (oldValueTags.some((tag) => tag.toLowerCase() === (newValue.trim()).toLowerCase())) {
      this.atualizarCondicao(
        bloco.id,
        grupo.id,
        condicaoIndex,
        "inputFilterTagValue",
        ""
      )

      e.preventDefault();
      return;
    }

    const newTagValue =
      oldValue == "" || !oldValue ? (newValue.trim()) : oldValue + "," + (newValue.trim());

    this.atualizarCondicao(
      bloco.id,
      grupo.id,
      condicaoIndex,
      "valor",
      newTagValue
    )

    this.atualizarCondicao(
      bloco.id,
      grupo.id,
      condicaoIndex,
      "inputFilterTagValue",
      ""
    )

    e.preventDefault();
  }

  atualizarAcao = (index, campo, valor) => {
    const novasAcoes = [...this.state.acoes];
    novasAcoes[index][campo] = valor;
    this.setState({ acoes: novasAcoes });
  };

  atualizarAcaoTipo = (index, actionsFields, valor) => {
    const getAction = actionsFields?.find((field) => field?.id == valor);

    const getFieldType = getAction?.fieldtype ?? null;
    const getFieldName = getAction?.name ?? null;

    if (this.fieldHasNewCall(getFieldName)) {
      this.atualizarAcao(index, "newCallProperties", "false");
    }

    if (this.fieldHasSetCategory(getFieldName)) {
      this.atualizarAcao(index, "setCategoryOrganizationValue", "false");
    }

    if (getFieldType == "boleano") {
      this.atualizarAcao(index, "valor", "false");
    }

    this.atualizarAcao(index, "tipo", valor);
  };

  handleAdicionarTag = (index, acao) => {
    const oldValue = acao?.valor ?? "";

    const tagValue = acao?.tagValue ?? "";

    if (tagValue.trim() === "") return;

    const oldValueTags = oldValue?.split(",")?.filter((ac) => ac) ?? [];
      
      if (oldValueTags.some((tag) => tag.toLowerCase() === tagValue.toLowerCase())){
        this.atualizarAcao(index, "tagValue", null);

        return;
      }

    const newTagValue =
      oldValue === "" ? tagValue : oldValue + "," + tagValue.trim();

    this.atualizarAcao(index, "valor", newTagValue);
    
    this.atualizarAcao(index, "tagValue", null);
  };

  handleActionTagInputKeyDown(event, acao, index) {
    const newValue = acao?.tagValue?.trim();

    if (event.key === "Enter" && newValue) {
      if (newValue == ""){
        event.preventDefault();
        return;
      };

      this.handleAdicionarTag(index, acao);
      
      event.preventDefault();
    }
  }

  handleRemoverTag = (index, acao, tagIndex) => {
    const oldValue = acao?.valor ?? "";
    const oldTags = oldValue?.split(",")?.filter((ac) => ac);

    oldTags.splice(tagIndex, 1);

    this.atualizarAcao(index, "valor", oldTags.join(","));
  };

  selecionadoTemDePara = (eventos, groupIndex) => {
    return eventos.grupo[groupIndex]?.tipo?.includes("DE -> PARA") || eventos.grupo[groupIndex]?.tipo?.includes("O campo personalizado foi atualizado");
  };

  filtroCampoQueNaoPrecisaDoValor = (campo) => {
    const filtroTipoQueNaoPrecisa = ["chamados"];
    const filtroCampoQueNaoPrecisa = ["anexo"];

    const idCampoSelecionado = campo?.tipo?.split("_")?.[1] ?? "";

    if (!idCampoSelecionado) return false;

    const campoSelecionado = (campo?.filtersFields ?? [])?.find((filter)=> filter?.conditioncriteriaid?.toString() == idCampoSelecionado) ?? "";

    if (!campoSelecionado) return false;

    const conditionDoCampo = filtroCampoQueNaoPrecisa.some(campo => campoSelecionado.condition.toLowerCase().includes(campo));
    const conditionDoTipo = filtroTipoQueNaoPrecisa.some(tipo => campoSelecionado.field.toLowerCase().includes(tipo));

    return conditionDoTipo && conditionDoCampo;
  };


  eventosQueNaoPrecisaDoCampoValor = (groupIndex) => {
    const eventos = this.state.eventos;

    const eventosQueNaoPrecisa = ["acompanhamento adicionado", "anexo foi adicionado", "avaliação do cliente foi recebida"];
    
    const eventoSelecionado = eventos.grupo[groupIndex]?.tipo ?? "";
    
    if (!eventoSelecionado) return false;
    
    const _eventoSelecionado = eventoSelecionado.split("_")?.[2]?.toLowerCase() ?? "";

    const condition = eventosQueNaoPrecisa.some(evento => _eventoSelecionado.includes(evento));

    return condition;
  };

  eventosQueNaoPrecisaDoCampoValor = (groupIndex) => {
    const eventos = this.state.eventos;

    const eventosQueNaoPrecisa = ["acompanhamento adicionado", "anexo foi adicionado", "avaliação do cliente foi recebida"];
    
    const eventoSelecionado = eventos.grupo[groupIndex]?.tipo ?? "";
    
    if (!eventoSelecionado) return false;
    
    const _eventoSelecionado = eventoSelecionado.split("_")?.[2]?.toLowerCase() ?? "";

    const condition = eventosQueNaoPrecisa.some(evento => _eventoSelecionado.includes(evento));

    return condition;
  };

  formatarLabelEvento = (evento) => {
    if (!evento) return "";

    return evento.split("(DE -> PARA)")?.[0] ?? "";
  };

  getLgGrid = (condition) => {
    return condition ? 4 : 6;
  };

  fieldHasEmailConfig = (name) => {
    if (!name) return false;

    const _name = name.toLowerCase();

    return _name.includes("email") || _name.includes("e-mail");
  };

  fieldHasNewCall = (name) => {
    if (!name) return false;

    return name.toLowerCase().includes("criar um novo chamado");
  };

  fieldHasSetCategory = (name) => {
    if (!name) return false;

    const _name = name.toLowerCase().replace(/\s/g, "");

    return _name.includes("definircategoriacomo");
  };

  getIdFromFieldValue = (value) => {
    if (!value) return null;

    const parts = value.split("_");

    return parts.length > 1 ? parseInt(parts[1]) : null;
  };

  addAnyToArray = (array) => {
    const any = { id: "ANY", name: "Qualquer valor" };

    if (!array || !Array.isArray(array)) {
      return [];
    }

    if (array.length == 0) {
      return [any];
    }

    const exists = array.some(
      (item) => item.id == any.id && item.name == any.name
    );

    if (!exists) {
      return [any, ...array];
    }

    return array;
  };

  renderInputsByFieldtype = (acao, index) => {
    const getAction = this.state.actionFieldDetail?.find(
      (field) => field?.id == acao?.tipo
    );
    const getFieldName = getAction?.name ?? null;
    const getFieldType = getAction?.fieldtype ?? null;
    const label = getAction?.label ?? "Valor";

    if (getFieldName == "Definir valor campo personalizado") {
      return (
        <>
          <Grid item xs={12} sm={6}>
            <Grid item xs={12} sm={12}>
              <RealSimpleAutoComplete
                style={{ background: "white", fullWidth: true }}
                label="Organização"
                options={this.state.organizationsFilterList}
                stateName="organizationId"
                changeSelect={(stateName, value, text = "") => {
                  this.getOrganizationFields(value?.id);
                }}
                onFocus={this.getFilterOrganizations}
                loading={this.state.loadingOrganizationFilter}
                selected={this.state.organizationsFilterList.find(
                  (item) => item.id == acao.organizationId
                )}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid item xs={12} sm={12}>
              <SimpleAutoComplete
                style={{ background: "white", fullWidth: true }}
                label="Campos personalizados"
                options={this.state.customOrganizationFilterFields}
                stateName="organizationFieldId"
                changeSelect={(stateName, value, text = "") => {
                  const novasAcoes = [...this.state.acoes];

                  if (value && value.id && value.organizationfieldtype && value.organizationfieldtype == 9) {
                    novasAcoes[index][stateName] = value?.id;
                    novasAcoes[index]["valor"] = new Date();
                    this.setState({ acoes: novasAcoes });
                    return;
                  }

                  novasAcoes[index]["organizationfieldtype"] = value.organizationfieldtype || null;
                  novasAcoes[index]["valor"] = null;
                  this.setState({ acoes: novasAcoes });

                  this.atualizarAcao(index, stateName, value?.id);
                }}
                selected={() => {
                  return (
                    this.state.customOrganizationFilterFields.find(
                      (item) => item.id == acao.organizationFieldId
                    ) ?? null
                  );
                }}
              />
            </Grid>
          </Grid>

          {acao.organizationFieldId != null && (
            this.returnFields(acao.organizationFieldId, index, acao.valor)
          )}
          
        </>
      );
    }

    if (getFieldName == "Adicionar Ação Padrão") {
      return (
        <Grid item xs={12} sm={6}>
          <RealSimpleAutoComplete
            style={{ background: "white", fullWidth: true }}
            label="Ação do chamado"
            options={this.state.defaultactionFilterList}
            stateName=""
            changeSelect={(stateName, value) =>
              this.atualizarAcao(index, "valor", value?.id)
            }
            onFocus={this.getFilterDefaultAction}
            loading={this.state.loadingDefaultactionFilter}
            selected={() => {
              return (
                this.state.defaultactionFilterList.find(
                  (item) => item.id == acao.valor
                ) ?? null
              );
            }}
          />
        </Grid>
      );
    }

    if (getFieldName == "Definir tipo como") {
      return (
        <Grid item xs={12} sm={6}>
          <RealSimpleAutoComplete
            style={{ background: "white", fullWidth: true }}
            label="Tipo do chamado"
            options={this.state.typeFilterList}
            stateName=""
            changeSelect={(stateName, value) =>
              this.atualizarAcao(index, "valor", value?.id)
            }
            onFocus={this.getFilterType}
            loading={this.state.loadingTypeFilter}
            selected={() => {
              return (
                this.state.typeFilterList.find(
                  (item) => item.id == acao.valor
                ) ?? null
              );
            }}
          />
        </Grid>
      );
    }

    if (getFieldName == "Definir prioridade como") {
      return (
        <Grid item xs={12} sm={6}>
          <RealSimpleAutoComplete
            style={{ background: "white", fullWidth: true }}
            label="Prioridade do chamado"
            options={this.state.priorityFilterList}
            stateName=""
            changeSelect={(stateName, value) =>
              this.atualizarAcao(index, "valor", value?.id)
            }
            onFocus={this.getFilterPriority}
            loading={this.state.loadingPriorityFilter}
            selected={() => {
              return (
                this.state.priorityFilterList.find(
                  (item) => item.id == acao.valor
                ) ?? null
              );
            }}
          />
        </Grid>
      );
    }

    if (getFieldName == "Definir status como") {
      return (
        <Grid item xs={12} sm={6}>
          <RealSimpleAutoComplete
            style={{ background: "white", fullWidth: true }}
            label="Status do chamado"
            options={this.state.statusFilterList}
            stateName=""
            changeSelect={(stateName, value) =>
              this.atualizarAcao(index, "valor", value?.id)
            }
            onFocus={this.getFilterStatus}
            loading={this.state.loadingStatusFilter}
            selected={() => {
              return (
                this.state.statusFilterList.find(
                  (item) => item.id == acao.valor
                ) ?? null
              );
            }}
          />
        </Grid>
      );
    }

    if (getFieldName == "Atribuir Agente") {
      return (
        <Grid item xs={12} sm={6}>
          <RealSimpleAutoComplete
            style={{ background: "white", fullWidth: true }}
            label="Atribuir Agente"
            options={this.state.assignedUserFilterList}
            stateName=""
            changeSelect={(stateName, value) =>
              this.atualizarAcao(index, "valor", value?.id)
            }
            onFocus={this.getFilterAssignedUser}
            loading={this.state.loadingAssignedUserFilter}
            selected={() => {
              return (
                this.state.assignedUserFilterList.find(
                  (item) => item.id == acao.valor
                ) ?? null
              );
            }}
          />
        </Grid>
      );
    }

    if (getFieldName == "Atribuir Time") {
      return (
        <Grid item xs={12} sm={6}>
          <RealSimpleAutoComplete
            style={{ background: "white", fullWidth: true }}
            label="Time do chamado"
            options={this.state.techinicalTeamFilterList}
            stateName=""
            changeSelect={(stateName, value) =>
              this.atualizarAcao(index, "valor", value?.id)
            }
            onFocus={this.getFilterTechinicalTeam}
            loading={this.state.loadingTechinicalTeamFilter}
            selected={() => {
              return (
                this.state.techinicalTeamFilterList.find(
                  (item) => item.id == acao.valor
                ) ?? null
              );
            }}
          />
        </Grid>
      );
    }

    if (this.fieldHasSetCategory(getFieldName)) {
      return (
        <>
          <Grid item xs={12} sm={6}>
            <RealSimpleAutoComplete
              style={{ background: "white", fullWidth: true }}
              label="Organização"
              options={this.state.organizationsFilterList}
              stateName="organizationId"
              changeSelect={(stateName, value) =>
                this.changeValuesPerFilter(stateName, value, "acao", index)
              }
              onFocus={this.getFilterOrganizations}
              loading={this.state.loadingOrganizationFilter}
              selected={
                this.state.filtersCalled?.acao?.organizationId?.[index] ?? null
              }
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <RealSimpleAutoComplete
              style={{ background: "white", fullWidth: true }}
              label="Categoria do Chamado"
              options={
                this.state.categoriesFilterList?.acao?.[index] ?? []
              }
              stateName=""
              changeSelect={(_, value) => {
                this.atualizarAcao(
                  index,
                  "setCategoryOrganizationId",
                  value?.id
                )
              }}
              onFocus={() => {
                const orgId = this.state.filtersCalled?.acao?.organizationId?.[index] ?? null;
                this.getFilterCategoriesByOrganization(orgId, "acao", index);
              }}
              loading={this.state.loadingCategoryFilter}
              selected={
                this.state.categoriesFilterList?.acao?.[index]
                  .find(item => item.id == acao.setCategoryOrganizationId) ?? null
              }
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormLabel component="legend">
              Aplicar para todas as organizações que contém este valor
            </FormLabel>

            <FormControlLabel
              defaultChecked={acao.setCategoryOrganizationValue === "true"}
              control={
                <Switch
                  onChange={(e) =>
                    this.atualizarAcao(
                      index,
                      "setCategoryOrganizationValue",
                      e.target.checked.toString()
                    )
                  }
                />
              }
              label={
                acao.setCategoryOrganizationValue === "true" ? "Sim" : "Não"
              }
            />
          </Grid>
        </>
      );
    }

    if (this.fieldHasNewCall(getFieldName)) {
      return (
        <>
          <Grid item xs={12} sm={6}>
            <Stack
              spacing={1}
              direction="row"
              alignItems={"center"}
              justifyContent={"center"}
            >
              <TextField
                fullWidth
                label="Titulo do chamado"
                value={acao.newCallTitle ?? ""}
                onChange={(e) =>
                  this.atualizarAcao(index, "newCallTitle", e.target.value)
                }
                placeholder="Título do chamado"
                error={!!this.state.errors.acoes?.[index]?.valor}
              />

              <AddCommonPlaceholder
                onChange={(value) => {
                  this.atualizarAcao(index, "newCallTitle", value);
                }}
                value={acao.newCallTitle}
              />
            </Stack>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Stack
              spacing={2}
              direction="row"
              alignItems={"center"}
              justifyContent={"center"}
            >
              <TextField
                fullWidth
                label="Descrição do chamado"
                multiline
                rows={8}
                value={acao.newCallDescription ?? ""}
                onChange={(e) =>
                  this.atualizarAcao(
                    index,
                    "newCallDescription",
                    e.target.value
                  )
                }
                placeholder="Descrição do chamado"
                error={!!this.state.errors.acoes?.[index]?.valor}
                helperText={this.state.errors.acoes?.[index]?.valor}
              />

              <AddCommonPlaceholder
                onChange={(value) => {
                  this.atualizarAcao(index, "newCallDescription", value);
                }}
                value={acao.newCallDescription}
              />
            </Stack>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Grid item xs={12} sm={12}>
              <RealSimpleAutoComplete
                style={{ background: "white", fullWidth: true }}
                label="Organização"
                options={this.state.organizationsFilterList}
                stateName="organizationId"
                changeSelect={(stateName, value, text = "") => {
                  this.atualizarAcao(index, "newCallOrganizationId", value?.id);
                }}
                onFocus={this.getFilterOrganizations}
                loading={this.state.loadingOrganizationFilter}
                selected={this.state.organizationsFilterList.find(
                  (item) => item.id == acao.newCallOrganizationId
                )}
              />
            </Grid>

            <Grid item xs={12} sm={12} mt={2}>
              <FormLabel component="legend">
                Herdar propriedades existentes
              </FormLabel>

              <FormControlLabel
                defaultChecked={acao.newCallProperties == "true"}
                control={
                  <Switch
                    onChange={(e) =>
                      this.atualizarAcao(
                        index,
                        "newCallProperties",
                        e.target.checked.toString()
                      )
                    }
                  />
                }
                label={acao.newCallProperties == "true" ? "Sim" : "Não"}
              />
            </Grid>
          </Grid>
        </>
      );
    }

    if (this.fieldHasEmailConfig(getFieldName)) {
      return (
        <>
          <Grid item xs={12} sm={6}>
            {getFieldName?.toLowerCase().includes("agente") && (
              <RealSimpleAutoComplete
                style={{ background: "white", fullWidth: true }}
                label="Usuário"
                options={this.state.assignedUserFilterList}
                stateName=""
                changeSelect={(stateName, value) =>
                  this.atualizarAcao(index, "requestingUserId", value?.id)
                }
                onFocus={this.getFilterAssignedUser}
                loading={this.state.loadingAssignedUserFilter}
                selected={() => {
                  return (
                    this.state.assignedUserFilterList.find(
                      (item) => item.id == acao.requestingUserId
                    ) ?? null
                  );
                }}
              />
            )}
          </Grid>

          <Grid item xs={12} sm={12}>
            <EmailConfig
              onChangeSubject={(newSubject) => {
                this.atualizarAcao(index, "subject", newSubject);
              }}
              onChangeBody={(newBody) => {
                this.atualizarAcao(index, "body", newBody);
              }}
              bodyValue={acao.body}
              subjectValue={acao.subject}
            />

            {!!this.state.errors.acoes?.[index]?.valor && (
              <FormHelperText error={!!this.state.errors.acoes?.[index]?.valor}>
                {this.state.errors.acoes?.[index]?.valor}
              </FormHelperText>
            )}
          </Grid>
        </>
      );
    }

    if (getFieldType == "múltiplos valores") {
      const acaoSplit = acao?.valor?.split(",")?.filter((ac) => ac);

      return (
        <Grid item xs={12} sm={8}>
          <Stack spacing={2} direction="column">
            <Stack direction="row" spacing={2}>
              <TextField
                fullWidth
                label={label}
                 value={acao?.tagValue ?? ""}
                onChange={(e) => this.atualizarAcao(index, "tagValue", e.target.value)}
                placeholder="Valor para a ação"
                onKeyDown={(e) =>
                  this.handleActionTagInputKeyDown(
                    e,
                    acao,
                    index
                  )}
              />

              <Button
                aria-label="addNewValue"
                onClick={() => this.handleAdicionarTag(index, acao)}
              >
                <AddRoundedIcon />
              </Button>
            </Stack>

            {!!acaoSplit?.length && (
              <Stack direction="row" gap={1} flexWrap={"wrap"}>
                {acaoSplit?.map((tag, tagIndex) => (
                  <Chip
                    key={tagIndex}
                    label={tag}
                    color="primary"
                    variant="outlined"
                    onDelete={() =>
                      this.handleRemoverTag(index, acao, tagIndex)
                    }
                  />
                ))}
              </Stack>
            )}

            {!!this.state.errors.acoes?.[index]?.valor && (
              <FormHelperText error={!!this.state.errors.acoes?.[index]?.valor}>
                {this.state.errors.acoes?.[index]?.valor}
              </FormHelperText>
            )}
          </Stack>
        </Grid>
      );
    }

    if (getFieldType == "boleano") {
      return (
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            defaultChecked={acao.valor == "true"}
            control={
              <Switch
                onChange={(e) =>
                  this.atualizarAcao(
                    index,
                    "valor",
                    e.target.checked.toString()
                  )
                }
              />
            }
            label={acao.valor == "true" ? "Sim" : "Não"}
          />
        </Grid>
      );
    }

    if (getFieldType == "texto rico") {
      return (
        <Grid item xs={12} sm={12}>
          <Stack
            spacing={1}
            direction="row"
            alignItems={"center"}
            justifyContent={"center"}
          >
            <TextField
              id="texto-rico"
              fullWidth
              label={label}
              multiline
              rows={8}
              value={acao.valor ?? ""}
              onChange={(e) =>
                this.atualizarAcao(index, "valor", e.target.value)
              }
              placeholder="Valor para a ação"
              error={!!this.state.errors.acoes?.[index]?.valor}
              helperText={this.state.errors.acoes?.[index]?.valor}
            />

            <AddCommonPlaceholder
              onChange={(value) => {
                this.atualizarAcao(index, "valor", value);
              }}
              value={acao.valor}
            />
          </Stack>
        </Grid>
      );
    }

    if (getFieldType == "numero") {
      return (
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="number"
            label={label}
            value={acao.valor}
            onChange={(e) => this.atualizarAcao(index, "valor", e.target.value)}
            placeholder="Valor para a ação"
            error={!!this.state.errors.acoes?.[index]?.valor}
            helperText={this.state.errors.acoes?.[index]?.valor}
          />
        </Grid>
      );
    }

    return (
      <Grid item xs={12} sm={6}>
        <Stack
          spacing={1}
          direction="row"
          alignItems={"center"}
          justifyContent={"center"}
        >
          <TextField
            fullWidth
            label={label}
            value={acao.valor ?? ""}
            onChange={(e) => this.atualizarAcao(index, "valor", e.target.value)}
            placeholder="Valor para a ação"
            error={!!this.state.errors.acoes?.[index]?.valor}
            helperText={this.state.errors.acoes?.[index]?.valor}
          />

          <AddCommonPlaceholder
            onChange={(value) => {
              this.atualizarAcao(index, "valor", value);
            }}
            value={acao.valor}
          />
        </Stack>
      </Grid>
    );
  };

  errorsOnBlocosFiltro = (
    errors,
    blocoIndex,
    grupoIndex,
    condicaoIndex,
    value
  ) => {
    return {
      error:
        errors?.blocosFiltro?.[blocoIndex]?.[grupoIndex]?.[condicaoIndex] &&
        !value,
      helperText:
        errors?.blocosFiltro?.[blocoIndex]?.[grupoIndex]?.[condicaoIndex] || "",
      hasDuplicateFilter:
        errors?.blocosFiltro?.[blocoIndex]?.[grupoIndex]?.hasDuplicateFilter || null,
    };
  };

  errorsOnBlocosEventos = (errors, groupIndex, campo, value) => {
    return {
      error: errors?.eventos?.grupo?.[groupIndex]?.[campo] && !value,
      helperText: errors?.eventos?.grupo?.[groupIndex]?.[campo] || "",
    };
  };

  cleanListFromAny = (listForFilter, listForFilterField, listPopulate, listPopulateField, currentIndex, isCustomFieldValue = false) => {
    if (!Array.isArray(listForFilter) || listForFilter.length === 0) return [];

    if (!Array.isArray(listPopulate) || listPopulate.length === 0) return listForFilter;

    let _listPopulate = [...listPopulate];

    _listPopulate = _listPopulate.filter((_, index) => index !== currentIndex);

    let listWithFilterVariables = new Set();

    if (isCustomFieldValue) {
      listWithFilterVariables = new Set(
        _listPopulate
          .filter(i => this.getIdFromFieldValue(i[listPopulateField]))
          .map(item => this.getIdFromFieldValue(item[listPopulateField]))
      );
    } else {
      listWithFilterVariables = new Set(
        _listPopulate.filter(i => i[listPopulateField])
          .map(item => item[listPopulateField])
      );
    }

    const actionsIdToNotRemove = [4, 9, 19, 20];

    const filter = listForFilter
      .filter(item => {
        const defaultCondition = item[listForFilterField] && !listWithFilterVariables.has(item[listForFilterField]);

        if (!isCustomFieldValue && actionsIdToNotRemove.includes(item.id)) {
          return true;
        }

        return defaultCondition;
      });

    return filter;
  }

  hasDuplicates(arr, keysString) {
    if (!Array.isArray(arr) || arr.length === 0){
      this.setState({
        hasDuplicates: false
      })
      return false;
    } 
    
    const keys = keysString.split(",")
    ?.filter(Boolean)
    ?.map(k => k?.trim());

    if (keys?.length === 0){
      this.setState({
        hasDuplicates: false
      })
      return false;
    }
    
    const seen = new Set();
    
    for (const item of arr) {
      const key = keys
      ?.map(k => item?.[k])
      ?.join("|");

      if (seen?.has(key)) {
        this.setState({
          hasDuplicates: true
        });
        return true;
      }
      seen?.add(key);
    }

    this.setState({
      hasDuplicates: false
    });
    return false;
  }

  hasDuplicateActionFields = (_arr, type, key1, key2) => {
    if (!Array.isArray(_arr) || _arr.length === 0) {
      return false;
    }

    const arr = _arr.filter(item => item.tipo == type);
    if (!Array.isArray(arr) || arr.length === 0) {
      return false;
    }

    const seen = new Set();

    for (const item of arr) {
      const key = `${item?.[key1]}|${item?.[key2]}`;
      if (seen?.has(key)) {
        return true;
      }
      seen?.add(key);
    }

    return false;
  }

  closeNotification = () => {
    this.setState({ openNotification: false });
  };

  validarFormulario() {
    const form = this.state;

    const novosErros = {};
    const acoesErros = [];

    const commonErrorSameFilterText =
      "Condições duplicadas encontradas. Por favor, verifique os campos.*";

    const commonErrorText = "Campo obrigatório.";
    const commonErrorGroupText = "Campos obrigatórios não preenchidos.";
    const commonErrorEmailText =
      "O corpo, assunto e id do usuário solicitante são obrigatórios.";

    const errorDuplicateCamposPersonalizadosAcoes =
      "Existem ações com campos personalizados duplicados. Por favor, verifique os campos.*";
    const errorDuplicateEnvioEmailMesmoUsuario =
      "Existem ações de envio de e-mail para o mesmo usuário. Por favor, verifique os campos.*";

    // INICIO VALIDAÇÃO DAS INFORMAÇÕES BÁSICAS
    /*if (!form.nomeAutomacao.trim()) {
      novosErros.nomeAutomacao = commonErrorText;
    }

    if (!form.descricao.trim()) {
      novosErros.descricao = commonErrorText;
    }*/
    // FIM VALIDAÇÃO DAS INFORMAÇÕES BÁSICAS

    // INICIO VALIDAÇÃO DOS EVENTOS
    /*if (form.typeAutomation == 2 && form.eventos.grupo.length > 0) {
      form.eventos.grupo.forEach((evento, index) => {
        const conditionToTemPara = this.selecionadoTemDePara(
          form.eventos,
          index
        );

        const itemErros = {};
        if (!evento.tipo && !conditionToTemPara) {
          itemErros.tipo = commonErrorText;
        }

        if (!evento.valor && !conditionToTemPara) {
          itemErros.valor = commonErrorText;
        }

        if (conditionToTemPara) {
          if (!evento.de || !evento.para) {
            itemErros.de = commonErrorText;
            itemErros.para = commonErrorText;
          }
        }
        if (Object.keys(itemErros).length > 0) {
          if (!novosErros.eventos) {
            novosErros.eventos = {};
          }
          if (!novosErros.eventos.grupo) {
            novosErros.eventos.grupo = [];
          }
          novosErros.eventos.grupo[index] = itemErros;
        }
      });

      if (Object.keys(novosErros.eventos || {}).length == 0) {
        delete novosErros.eventos; // Remove se não houver erros
      }
    }*/
    // FIM VALIDAÇÃO DOS EVENTOS

    // INICIO VALIDAÇÃO DOS BLOCOS DE FILTRO
    if (form.blocosFiltro.length == 0) {
      novosErros.blocosFiltro = commonErrorGroupText;
    } else {
      form.blocosFiltro.forEach((bloco, blocoIndex) => {
        if (bloco.grupos.length == 0) {
          if (!novosErros.blocosFiltro) {
            novosErros.blocosFiltro = {};
          }

          novosErros.blocosFiltro[blocoIndex] = commonErrorGroupText;
        } else {
          bloco.grupos.forEach((grupo, grupoIndex) => {
            if (grupo.condicoes.length == 0) {
              if (!novosErros.blocosFiltro) {
                novosErros.blocosFiltro = {};
              }

              if (!novosErros.blocosFiltro[blocoIndex]) {
                novosErros.blocosFiltro[blocoIndex] = {};
              }

              novosErros.blocosFiltro[blocoIndex][grupoIndex] =
                commonErrorGroupText;
            } else {
              grupo.condicoes.forEach((condicao, condicaoIndex) => {
                if (
                  !condicao.tipo ||
                  !condicao.campo ||
                  !condicao.operador ||
                  !condicao.valor
                ) {
                  if (!novosErros.blocosFiltro) {
                    novosErros.blocosFiltro = {};
                  }

                  if (!novosErros.blocosFiltro[blocoIndex]) {
                    novosErros.blocosFiltro[blocoIndex] = {};
                  }

                  if (!novosErros.blocosFiltro[blocoIndex][grupoIndex]) {
                    novosErros.blocosFiltro[blocoIndex][grupoIndex] = {};
                  }

                  novosErros.blocosFiltro[blocoIndex][grupoIndex][
                    condicaoIndex
                  ] = commonErrorGroupText;
                }
              });
            }

            if (this.hasDuplicates(grupo.condicoes, "campo,tipo,operador,valor")) {
              if (!novosErros.blocosFiltro) {
                novosErros.blocosFiltro = {};
              }

              if (!novosErros.blocosFiltro[blocoIndex]) {
                novosErros.blocosFiltro[blocoIndex] = {};
              }

              novosErros.blocosFiltro[blocoIndex][grupoIndex] = {
                ...novosErros.blocosFiltro[blocoIndex][grupoIndex],
                hasDuplicateFilter: commonErrorSameFilterText
              }
            }
          });
        }
      });

      if (Object.keys(novosErros.blocosFiltro || {}).length == 0) {
        delete novosErros.blocosFiltro; // Remove se não houver erros
      }
    }
    // FIM VALIDAÇÃO DOS BLOCOS DE FILTRO

    //INICIO VALIDAÇÃO DAS AÇÕES
    // Verifica se há campos personalizados duplicados nas ações
    if (this.hasDuplicateActionFields(form.acoes, 20, "organizationFieldId", "organizationId")) {
      (novosErros.customAcoes ??= []).push(`${errorDuplicateCamposPersonalizadosAcoes}`);
    }

    // Verifica se há envio de e-mail para o mesmo usuário nas ações
    if (this.hasDuplicateActionFields(form.acoes, 9, "tipo", "requestingUserId")) {
      (novosErros.customAcoes ??= []).push(errorDuplicateEnvioEmailMesmoUsuario);
    }

    form.acoes.forEach((acao, index) => {
      const itemErros = {};

      const getCustomField = this.state.customOrganizationFilterFields?.find(
        (field) => field?.id === acao?.organizationFieldId
      ) || {};

      const getAction = this.state.actionsFields?.find(
        (field) => field?.id == acao?.tipo
      );
      const getFieldName = getAction?.name ?? null;

      const isEmail = this.fieldHasEmailConfig(getFieldName);
      const isAgentEmail = getFieldName?.toLowerCase().includes("agente");
      const isSetCategory = this.fieldHasSetCategory(getFieldName);
      const isNewCall = this.fieldHasNewCall(getFieldName);

      if (!acao.tipo) {
        itemErros.tipo = commonErrorText;
      }

      if (
        !isEmail &&
        !isSetCategory &&
        !isNewCall &&
        (!acao.valor ||
          (typeof acao.valor == "string" && acao.valor?.trim() == ""))
      ) {
        itemErros.valor = commonErrorText;
      } else if (isEmail && isAgentEmail && (!acao?.body || !acao?.subject || !acao?.requestingUserId)) {
        itemErros.valor = commonErrorEmailText;
      } else if (isEmail && (!acao?.body || !acao?.subject)) {
        itemErros.valor = commonErrorEmailText;
      } else if (
        isSetCategory &&
        (!acao?.setCategoryOrganizationValue ||
          !acao?.setCategoryOrganizationId)
      ) {
        itemErros.valor = commonErrorGroupText;
      } else if (
        isNewCall &&
        (!acao?.newCallTitle ||
          !acao?.newCallDescription ||
          !acao?.newCallProperties ||
          !acao?.newCallOrganizationId)
      ) {
        itemErros.valor = commonErrorGroupText;
      }

      if (acao.tipo == 20 && !!acao.valor && getCustomField.organizationfieldtype == 10) {
        const regex = getCustomField.organizationfieldoptionsvalues.length > 0 ? getCustomField.organizationfieldoptionsvalues[0].name : '';

        const isValidValue = validateRegex(regex, acao.valor);

        if (!isValidValue) {
          itemErros.valor = "O valor não corresponde ao formato esperado para este campo.*";
        }
      }

      if (Object.keys(itemErros).length > 0) {
        acoesErros[index] = itemErros;
      }
    });

    if (acoesErros.length > 0) {
      novosErros.acoes = acoesErros;
    }
    // FIM DA VALIDAÇÃO DAS AÇÕES

    this.setState({ errors: novosErros });

    return Object.keys(novosErros).length == 0;
  }

  salvarAutomacao = () => {
    if (!this.validarFormulario()) {
      const {  hasDuplicates } = this.state;
      const notificationMessage = hasDuplicates
        ? "Existem condições duplicadas. Por favor, verifique os campos."
        : "Por favor, preencha todos os campos obrigatórios."; 

      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage,
      });
      return;
    }

    this.setState({ loading: true });

    // EVENTOS DATA
    const automationeventdetails = this.state.eventos.grupo.map((evento) => {
      const id = this.getIdFromFieldValue(evento.tipo);
      const eventid = this.state.eventsActionOwner.find(
        (ea) => ea?.id == id
      )?.eventid;

      return {
        automationeventid: eventid, //o id do campo "evento"
        automationeventcriterias: [
          {
            fromvalue: evento?.valor || evento?.de, //autoexplicativo
            tovalue: evento?.para, //autoexplicativo
          },
        ],
      };
    });

    // FILTROS DATA
    const automationfilters = this.state.blocosFiltro.map((bloco) => {
      const automationlogicaloperatorid =
        bloco?.grupos?.[0]?.operadorLogico?.id || 1; //o id da operação logica, se é and ou or, fora dos blocos

      const automationconditions = bloco?.grupos?.[0]?.condicoes?.map(
        (condicao) => {
          const fieldId = this.getIdFromFieldValue(condicao.campo);
          const condtiontypeid = this.state.filtersFields?.find(
            (field) => field?.id == fieldId
          )?.fieldid;

          return {
            automationlogicaloperatorid, //o id da operação logica, se é and ou or dentro dos blocos
            automationconditioncriteriaid: this.getIdFromFieldValue(
              condicao.tipo
            ), //condition_criteria_id, sendo o id do campo tipo
            automationconditiontypeid: condtiontypeid, //o campo "campo"
            automationoperatorid: this.getIdFromFieldValue(condicao.operador), //o campo operador, sendo o id da operação, se é "está", "contém" etc
            casesensitive: false,
            automationconditionvalues: [
              //o campo valor, por enquanto, sempre vai ter apenas um valor
              {
                value: condicao.valor,
              },
            ],
          };
        }
      );

      return {
        automationlogicaloperatorid: bloco.operadorLogico?.id ?? 1, //o id da operação logica, se é and ou or, fora dos blocos
        automationconditions,
      };
    });

    //ACOES DATA
    const automationactiondetails = this.state.acoes.map((acao) => {
      const getAction = this.state.actionsFields?.find(
        (field) => field?.id == acao?.tipo
      );
      const actionFieldDetail = this.state.actionFieldDetail;

      const getActionid = getAction?.actionid ?? null;
      const getName = getAction?.name ?? null;

      if (getName == "Definir valor campo personalizado") {
        const getOrganizationFieldId = actionFieldDetail?.find(
          (field) => field?.name === getName
        )?.id;

        return {
          automationactionid: getActionid, //o id do campo "ação"
          automationactiondetaildatas: [
            {
              organizationfieldid: acao?.organizationFieldId, //o id do campo da ação
              automationactionfieldid: getOrganizationFieldId, //o id do campo da ação
              value: acao?.valor,
            },
          ],
        };
      }

      if (this.fieldHasSetCategory(getName)) {
        const getActionSetCategoryContainValue = actionFieldDetail?.find(
          (field) =>
            field?.name == getName &&
            field?.field == "apply_all_organizations_contain_value"
        )?.id;
        const getActionSetCategoryId = actionFieldDetail?.find(
          (field) =>
            field?.name == getName &&
            field?.field == "called.organization_caterory_id"
        )?.id;

        return {
          automationactionid: getActionid, //o id do campo "ação"
          automationactiondetaildatas: [
            {
              automationactionfieldid: getActionSetCategoryContainValue, //o id do campo da ação
              value: acao?.setCategoryOrganizationValue,
            },
            {
              automationactionfieldid: getActionSetCategoryId, //o id do campo da ação
              value: acao?.setCategoryOrganizationId,
            },
          ],
        };
      }

      if (this.fieldHasNewCall(getName)) {
        const getActionNewCallCalledTitle = actionFieldDetail?.find(
          (field) => field?.name == getName && field?.field == "called.title"
        )?.id;
        const getActionNewCallCalledDescription = actionFieldDetail?.find(
          (field) =>
            field?.name == getName && field?.field == "called.description"
        )?.id;
        const getActionNewCallCalledExisting = actionFieldDetail?.find(
          (field) =>
            field?.name == getName &&
            field?.field == "inherit_existing_properties"
        )?.id;
        const getActionNewCallCalledOrganization = actionFieldDetail?.find(
          (field) =>
            field?.name === getName && field?.field === "called.organization_id"
        )?.id;

        return {
          automationactionid: getActionid, //o id do campo "ação"
          automationactiondetaildatas: [
            {
              automationactionfieldid: getActionNewCallCalledTitle, //o id do campo da ação
              value: acao?.newCallTitle,
            },
            {
              automationactionfieldid: getActionNewCallCalledDescription, //o id do campo da ação
              value: acao?.newCallDescription,
            },
            {
              automationactionfieldid: getActionNewCallCalledExisting, //o id do campo da ação
              value: acao?.newCallProperties,
            },
            {
              automationactionfieldid: getActionNewCallCalledOrganization, //o id do campo da ação
              value: acao?.newCallOrganizationId,
            },
          ],
        };
      }
      
      if (this.fieldHasEmailConfig(getName)) {
        const getActionEmailBodyId = actionFieldDetail?.find(
          (field) => field?.name == getName && field?.field == "email.body"
        )?.id;
        const getActionEmailSubjectId = actionFieldDetail?.find(
          (field) => field?.name == getName && field?.field == "email.subject"
        )?.id;

        const automationactiondetaildatas = [
          {
            automationactionfieldid: getActionEmailBodyId, //o id do campo da ação
            value: acao?.body,
          },
          {
            automationactionfieldid: getActionEmailSubjectId, //o id do campo da ação
            value: acao?.subject,
          },
        ];

        if (
          acao?.requestingUserId != "" && getName?.toLowerCase().includes("agente")
        ) {
          const getActionRequestingUserId = actionFieldDetail?.find(
            (field) =>
              field?.name === getName &&
              field?.field === "called.assigned_user_id"
          )?.id;

          automationactiondetaildatas.push({
            automationactionfieldid: getActionRequestingUserId, //o id do campo da ação
            value: acao?.requestingUserId,
          });
        }

        return {
          automationactionid: getActionid, //o id do campo "ação"
          automationactiondetaildatas: automationactiondetaildatas,
        };
      }

      return {
        automationactionid: getActionid, //o id do campo "ação"
        automationactiondetaildatas: [
          {
            automationactionfieldid: acao?.tipo, //o id do campo da ação
            value: acao?.valor,
          },
        ],
      };
    });

    const automationDataFromCreate = {
      id: this.state.automationDataToUpdate.id,
      automationeventactionownerid: this.state.eventos.acao, //O id se é agente, sistema, solicitante ou agente e solicitante
      automationtypeid: this.state.typeAutomation, //o campo automationtypeid
      name: this.state.nomeAutomacao,
      description: this.state.descricao,
      active: this.state.ativo,
      automationeventdetails:
        this.state.typeAutomation == 2 ? automationeventdetails : [],
      automationfilters,
      automationactiondetails,
    };

    let url = `/automation`;
    Api.put(url, automationDataFromCreate)
      .then((result) => {
        if (result.data.success) {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "success",
            notificationMessage: "Automação atualizada com sucesso!",
          });
        } else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data &&
              result.data.response &&
              result.data.response.data &&
              result.data.response.data.errors &&
              result.data.response.data.errors[0]
                ? result.data.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
          Api.kickoff(result);
        }
      })
      .catch((err) => {
        const intl = this.props.intl;
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            err.response &&
            err.response.data &&
            err.response.data.errors &&
            err.response.data.errors[0]
              ? err.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(err);
      });
  };

  changeValuesPerFilter = (stateName, value, tipo, index) => {
    this.setState(prev => {
      const filtersCalled = { ...prev.filtersCalled };
      const section = { ...(filtersCalled[tipo] ?? {}) };

      // Atualiza o campo alvo (ex.: organizationId[index] = value)
      const obj = { ...(section[stateName] ?? {}) };
      obj[index] = value;
      section[stateName] = obj;

      // Se mudou a organização desse "evento", zera categoria e limpa lista
      let categoriesFilterList = prev.categoriesFilterList;
      if ((tipo === "eventos" || tipo === "valor" || tipo === "acao") && stateName === "organizationId") {
        // zera seleção de categoria naquele índice
        const categoriaObj = { ...(section["categoriaId"] ?? {}) };
        categoriaObj[index] = null; // ou "" dependendo do seu componente
        section["categoriaId"] = categoriaObj;

        // limpa as opções de categoria para forçar recarga
        if(tipo === "eventos"){
          const eventosMap = { ...(prev.categoriesFilterList?.eventos ?? {}) };
          eventosMap[index] = []; // sem opções até buscar de novo
          categoriesFilterList = {
            ...prev.categoriesFilterList,
            eventos: eventosMap,
          };
        }

        if(tipo == "valor"){
          const valorMap = { ...(prev.categoriesFilterList?.valor ?? {}) };
          valorMap[index] = []; // sem opções até buscar de novo
          categoriesFilterList = {
            ...prev.categoriesFilterList,
            valor: valorMap,
          };
        }
        
        if(tipo === "acao"){
          const acaoMap = { ...(prev.categoriesFilterList?.acao ?? {}) };
          acaoMap[index] = []; // sem opções até buscar de novo
          categoriesFilterList = {
            ...prev.categoriesFilterList,
            acao: acaoMap,
          };
        }
      }

      filtersCalled[tipo] = section;

      return { filtersCalled, categoriesFilterList };
    });

  };

  render() {
    const {
      nomeAutomacao,
      descricao,
      ativo,
      blocosFiltro,
      acoes,
      eventos,
      errors,
    } = this.state;
    const { classes, headerMenu, actionsHeaderMenu } = this.props;

    const fieldField = this.state.fieldField;
    const actionsFields = this.state.actionsFields;

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`;
    }

    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(
            classes.content,
            {
              [classes.contentShift]: headerMenu.open,
            },
            classes.actionsContent,
            {
              [classes.actionscontentShift]: actionsHeaderMenu.open,
            }
          )}
        >
          <div className={classes.drawerHeader} />
          <Container component="main" maxWidth="lg">
            <CssBaseline />
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <Grid container spacing={6}>
                <Grid item xs={12} sm={4}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={browserHistory.goBack}
                  >
                    {<FormattedMessage id="back" />}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={8} />
              </Grid>
              <Avatar style={{ backgroundColor: "#3f51b4" }}>
                <AutomationIcon />
              </Avatar>
              <Typography
                component="h1"
                variant="h5"
                style={{ marginTop: "10px" }}
              >
                {<FormattedMessage id="add.authentication" />}
                <Title />
              </Typography>
              <form name="myForm" className={classes.form}>
                <Box sx={{ maxWidth: 1000, mx: "auto", p: 3 }}>
                  <Typography variant="h4" component="h1" gutterBottom>
                    Edição da Automação
                  </Typography>

                  {/* Informações básicas */}
                  <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
                    <Typography variant="h6" gutterBottom>
                      Informações Básicas
                    </Typography>

                    <TextField
                      label="Nome da Automação"
                      fullWidth
                      margin="normal"
                      value={nomeAutomacao}
                      onChange={this.handleNomeChange}
                      placeholder="Ex: Atribuir tickets urgentes"
                      error={!!this.state.errors.nomeAutomacao}
                      helperText={this.state.errors.nomeAutomacao}
                    />

                    <TextField
                      label="Descrição (opcional)"
                      fullWidth
                      margin="normal"
                      value={descricao ?? ""}
                      onChange={this.handleDescricaoChange}
                      multiline
                      rows={3}
                      placeholder="Descreva o propósito desta automação"
                      error={!!this.state.errors.descricao}
                      helperText={this.state.errors.descricao}
                    />

                    <FormControlLabel
                      control={
                        <Switch
                          checked={ativo}
                          onChange={this.handleAtivoChange}
                          color="primary"
                        />
                      }
                      label="Automação Ativa"
                      sx={{ mt: 1 }}
                    />
                  </Paper>

                  {/* Eventos */}
                  <Accordion defaultExpanded sx={{ mb: 3 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="eventos-content"
                      id="eventos-header"
                    >
                      <Typography variant="h6">Eventos</Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      {this.state.typeAutomation == 1 && (
                        <Alert severity="success" sx={{ mb: 2 }}>
                          Quando um chamado é criado
                        </Alert>
                      )}
                      {this.state.typeAutomation == 3 && (
                        <Alert severity="success" sx={{ mb: 2 }}>
                          Acionadores de horários
                        </Alert>
                      )}
                      {this.state.typeAutomation == 2 && (
                        <>
                          <Alert severity="success" sx={{ mb: 2 }}>
                            As ações serão executadas quando o(s) evento(s)
                            abaixo forem iniciado(s)
                          </Alert>

                          <Stack spacing={2} direction="row" sx={{ mb: 2 }}>
                            {this.state.events.map((item, index) => (
                              <FormControlLabel
                                key={item.name}
                                value={item.id}
                                label={item.name}
                                checked={eventos?.acao == item?.id ?? false}
                                control={<Checkbox />}
                                onChange={() =>
                                  this.atualizarEvento(index, "acao", item.id)
                                }
                              />
                            ))}
                          </Stack>

                          {eventos?.grupo?.map((evento, groupIndex) => (
                            <Paper
                              key={groupIndex}
                              variant="outlined"
                              sx={{ p: 2, mb: 2 }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  mb: 2,
                                }}
                              >
                                <Typography variant="subtitle2">
                                  Evento {groupIndex + 1}
                                </Typography>

                                {eventos?.grupo?.length > 1 && (
                                  <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() =>
                                      this.removerEvento(groupIndex)
                                    }
                                    aria-label="Remover evento"
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                )}
                              </Box>

                              <Grid container spacing={2}>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={6}
                                  lg={this.getLgGrid(
                                    this.selecionadoTemDePara(
                                      eventos,
                                      groupIndex
                                    )
                                  )}
                                >
                                  <FormControl
                                    fullWidth
                                    error={
                                      this.errorsOnBlocosEventos(
                                        errors,
                                        groupIndex,
                                        "tipo",
                                        evento.tipo
                                      ).error
                                    }
                                  >
                                    <InputLabel>Evento</InputLabel>
                                    <Select
                                      value={evento.tipo ?? ""}
                                      label="Evento"
                                      disabled={
                                        (eventos?.listAcoesDono ?? []).length ==
                                        0
                                      }
                                      onChange={(e) =>
                                        this.atualizarEvento(
                                          groupIndex,
                                          "tipo",
                                          e.target.value
                                        )
                                      }
                                    >
                                      {
                                      this.cleanListFromAny(eventos?.listAcoesDono, "id", eventos?.grupo, "tipo", groupIndex, true)
                                      .map(
                                        (item) => (
                                          <MenuItem
                                            key={item?.id}
                                            value={`tipo_${item?.id}_${item?.eventname}`}
                                          >
                                            {this.formatarLabelEvento(
                                              item?.eventname
                                            )}
                                          </MenuItem>
                                        )
                                      )}
                                    </Select>

                                    {this.errorsOnBlocosEventos(
                                      errors,
                                      groupIndex,
                                      "tipo",
                                      evento.tipo
                                    ).error && (
                                      <FormHelperText error>
                                        {
                                          this.errorsOnBlocosEventos(
                                            errors,
                                            groupIndex,
                                            "tipo",
                                            evento.tipo
                                          ).helperText
                                        }
                                      </FormHelperText>
                                    )}
                                  </FormControl>
                                </Grid>

                                {console.log(evento.valor, 'testevalor')}

                                {eventos.grupo[groupIndex]?.tipo?.includes("A data de previsão foi alterada") && (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={6}
                                    lg={this.getLgGrid(
                                      this.selecionadoTemDePara(
                                        eventos,
                                        groupIndex
                                      )
                                    )}
                                  >
                                    <SimpleDatePicker 
                                      label="Data de previsão"
                                      stateName="openDate" 
                                      changeDate={(
                                        stateName,
                                        value
                                      ) => {
                                        if(value && !isNaN(Date.parse(value))) {
                                          const formatted = new Date(value).toISOString().split('T')[0];
                                          this.atualizarEvento(
                                            groupIndex,
                                            "de",
                                            formatted
                                          );
                                        }
                                      }}
                                      currentDate={evento.valor}
                                      fullWidth={true}
                                      minDate={new Date()}
                                    />
                                  </Grid>
                                )}

                                {!this.selecionadoTemDePara(
                                  eventos,
                                  groupIndex
                                )
                                && !this.eventosQueNaoPrecisaDoCampoValor(groupIndex)  
                                && !eventos.grupo[groupIndex]?.tipo?.includes("A data de previsão foi alterada")
                                && (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={6}
                                    lg={this.getLgGrid(
                                      this.selecionadoTemDePara(
                                        eventos,
                                        groupIndex
                                      )
                                    )}
                                  >
                                    <TextField
                                      fullWidth
                                      label="Valor"
                                      value={evento.valor ?? ""}
                                      error={
                                        this.errorsOnBlocosEventos(
                                          errors,
                                          groupIndex,
                                          "valor",
                                          evento.valor
                                        ).error
                                      }
                                      helperText={
                                        this.errorsOnBlocosEventos(
                                          errors,
                                          groupIndex,
                                          "valor",
                                          evento.valor
                                        ).helperText
                                      }
                                      onChange={(e) =>
                                        this.atualizarEvento(
                                          groupIndex,
                                          "valor",
                                          e.target.value
                                        )
                                      }
                                      placeholder="Valor para o evento"
                                    />
                                  </Grid>
                                )}

                                {this.selecionadoTemDePara(
                                  eventos,
                                  groupIndex
                                ) && (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    lg={this.getLgGrid(
                                      this.selecionadoTemDePara(
                                        eventos,
                                        groupIndex
                                      )
                                    )}
                                  >
                                    {(() => {
                                      const tipo =
                                        eventos.grupo[groupIndex].tipo;
                                      switch (true) {
                                        case tipo.includes(
                                          "O campo personalizado foi atualizado"
                                        ):
                                          return (
                                            <>
                                              <RealSimpleAutoComplete
                                                style={{
                                                  background: "white",
                                                  fullWidth: true,
                                                }}
                                                label="Organização"
                                                options={
                                                  this.state
                                                    .organizationsFilterList
                                                }
                                                stateName="organizationId"
                                                changeSelect={(stateName, value) =>
                                                  this.getOrganizationFields(value?.id)
                                                }
                                                onFocus={
                                                  this.getFilterOrganizations
                                                }
                                                loading={
                                                  this.state
                                                    .loadingOrganizationFilter
                                                }
                                                selected={
                                                  this.state.filtersCalled?.eventos?.organizationId?.[groupIndex] ?? null
                                                }
                                              />
                                            </>
                                          );
                                        case tipo.includes(
                                          "Categoria foi atualizada"
                                        ):
                                          return (
                                            <>
                                              <RealSimpleAutoComplete
                                                style={{
                                                  background: "white",
                                                  fullWidth: true,
                                                }}
                                                label="Organização"
                                                options={
                                                  this.state
                                                    .organizationsFilterList
                                                }
                                                stateName="organizationId"
                                                changeSelect={(stateName, value) =>
                                                  this.changeValuesPerFilter(stateName, value, "eventos", groupIndex)
                                                }
                                                onFocus={
                                                  this.getFilterOrganizations
                                                }
                                                loading={
                                                  this.state
                                                    .loadingOrganizationFilter
                                                }
                                                selected={
                                                  this.state.filtersCalled?.eventos?.organizationId?.[groupIndex] ?? null
                                                }
                                              />
                                            </>
                                          );
                                        case tipo.includes(
                                          "Responsável foi atualizado"
                                        ):
                                          return (
                                            <RealSimpleAutoComplete
                                              style={{
                                                background: "white",
                                                fullWidth: true,
                                              }}
                                              label="De"
                                              options={this.addAnyToArray(
                                                this.state
                                                  .assignedUserFilterList
                                              )}
                                              stateName=""
                                              changeSelect={(
                                                stateName,
                                                value
                                              ) => {
                                                this.atualizarEvento(
                                                  groupIndex,
                                                  "de",
                                                  value?.id
                                                );
                                              }}
                                              onFocus={
                                                this.getFilterAssignedUser
                                              }
                                              loading={
                                                this.state
                                                  .loadingAssignedUserFilter
                                              }
                                              selected={() => {
                                                return (
                                                  this.addAnyToArray(
                                                    this.state
                                                      .assignedUserFilterList
                                                  ).find(
                                                    (item) =>
                                                      item.id == evento.de
                                                  ) ?? null
                                                );
                                              }}
                                            />
                                          );
                                        case tipo.includes(
                                          "O tipo foi alterado"
                                        ):
                                          return (
                                            <RealSimpleAutoComplete
                                              style={{
                                                background: "white",
                                                fullWidth: true,
                                              }}
                                              label="De"
                                              options={this.addAnyToArray(
                                                this.state.typeFilterList
                                              )}
                                              stateName=""
                                              changeSelect={(
                                                stateName,
                                                value
                                              ) => {
                                                this.atualizarEvento(
                                                  groupIndex,
                                                  "de",
                                                  value?.id
                                                );
                                              }}
                                              onFocus={this.getFilterType}
                                              loading={
                                                this.state.loadingTypeFilter
                                              }
                                              selected={() => {
                                                return (
                                                  this.addAnyToArray(
                                                    this.state.typeFilterList
                                                  ).find(
                                                    (item) =>
                                                      item.id == evento.de
                                                  ) ?? null
                                                );
                                              }}
                                            />
                                          );
                                        case tipo.includes(
                                          "O status foi alterado"
                                        ):
                                          return (
                                            <RealSimpleAutoComplete
                                              style={{
                                                background: "white",
                                                fullWidth: true,
                                              }}
                                              label="De"
                                              options={this.addAnyToArray(
                                                this.state.statusFilterList
                                              )}
                                              stateName=""
                                              changeSelect={(
                                                stateName,
                                                value
                                              ) => {
                                                this.atualizarEvento(
                                                  groupIndex,
                                                  "de",
                                                  value?.id
                                                );
                                              }}
                                              onFocus={this.getFilterStatus}
                                              loading={
                                                this.state.loadingStatusFilter
                                              }
                                              selected={() => {
                                                return (
                                                  this.addAnyToArray(
                                                    this.state.statusFilterList
                                                  ).find(
                                                    (item) =>
                                                      item.id == evento.de
                                                  ) ?? null
                                                );
                                              }}
                                            />
                                          );
                                        case tipo.includes(
                                          "A prioridade foi alterada"
                                        ):
                                          return (
                                            <RealSimpleAutoComplete
                                              style={{
                                                background: "white",
                                                fullWidth: true,
                                              }}
                                              label="De"
                                              options={this.addAnyToArray(
                                                this.state.priorityFilterList
                                              )}
                                              stateName=""
                                              changeSelect={(
                                                stateName,
                                                value
                                              ) => {
                                                this.atualizarEvento(
                                                  groupIndex,
                                                  "de",
                                                  value?.id
                                                );
                                              }}
                                              onFocus={this.getFilterPriority}
                                              loading={
                                                this.state.loadingPriorityFilter
                                              }
                                              selected={() => {
                                                return (
                                                  this.addAnyToArray(
                                                    this.state
                                                      .priorityFilterList
                                                  ).find(
                                                    (item) =>
                                                      item.id == evento.de
                                                  ) ?? null
                                                );
                                              }}
                                            />
                                          );
                                        default:
                                          return (
                                            <TextField
                                              label="De"
                                              fullWidth
                                              value={evento.de}
                                              error={
                                                this.errorsOnBlocosEventos(
                                                  errors,
                                                  groupIndex,
                                                  "de",
                                                  evento.de
                                                ).error
                                              }
                                              helperText={
                                                this.errorsOnBlocosEventos(
                                                  errors,
                                                  groupIndex,
                                                  "de",
                                                  evento.de
                                                ).helperText
                                              }
                                              onChange={(e) =>
                                                this.atualizarEvento(
                                                  groupIndex,
                                                  "de",
                                                  e.target.value
                                                )
                                              }
                                              placeholder="De"
                                            />
                                          );
                                      }
                                    })()}
                                  </Grid>
                                )}

                                {this.selecionadoTemDePara(
                                  eventos,
                                  groupIndex
                                ) &&
                                  eventos?.grupo?.[groupIndex].tipo.includes(
                                    "Categoria foi atualizada"
                                  ) && (
                                    <>
                                      <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        lg={this.getLgGrid(
                                          this.selecionadoTemDePara(
                                            eventos,
                                            groupIndex
                                          )
                                        )}
                                      >
                                        <RealSimpleAutoComplete
                                          className="select-categoria-focus"
                                          style={{ background: "white", fullWidth: true }}
                                          label="De"
                                          options={this.addAnyToArray(
                                            this.state.categoriesFilterList?.eventos?.[groupIndex] ?? []
                                          )}
                                          stateName="de"
                                          changeSelect={(_, value) => {
                                            this.atualizarEvento(groupIndex, "de", value?.id ?? null);
                                          }}
                                          onFocus={() => {
                                            const orgId = this.state.filtersCalled?.eventos?.organizationId?.[groupIndex] ?? null;
                                            this.getFilterCategoriesByOrganization(orgId, "eventos", groupIndex);
                                          }}
                                          loading={this.state.loadingCategoryFilter}
                                          selected={
                                            this.addAnyToArray(
                                              this.state.categoriesFilterList?.eventos?.[groupIndex] ?? []
                                            ).find(item => item.id == evento.de) ?? null
                                          }
                                        />
                                      </Grid>
                                      <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        lg={this.getLgGrid(
                                          this.selecionadoTemDePara(
                                            eventos,
                                            groupIndex
                                          )
                                        )}
                                      >
                                        <RealSimpleAutoComplete
                                          className="select-categoria-focus"
                                          style={{ background: "white", fullWidth: true }}
                                          label="Para"
                                          options={this.addAnyToArray(
                                            this.state.categoriesFilterList?.eventos?.[groupIndex] ?? []
                                          )}
                                          stateName="para"
                                          changeSelect={(_, value) => {
                                            this.atualizarEvento(groupIndex, "para", value?.id ?? null);
                                          }}
                                          onFocus={() => {
                                            const orgId = this.state.filtersCalled?.eventos?.organizationId?.[groupIndex] ?? null;
                                            this.getFilterCategoriesByOrganization(orgId, "eventos", groupIndex);
                                          }}
                                          loading={this.state.loadingCategoryFilter}
                                          selected={
                                            this.addAnyToArray(
                                              this.state.categoriesFilterList?.eventos?.[groupIndex] ?? []
                                            ).find(item => item.id == evento.para) ?? null
                                          }
                                        />
                                      </Grid>
                                    </>
                                  )}

                                  {this.selecionadoTemDePara(
                                  eventos,
                                  groupIndex
                                ) &&
                                  eventos?.grupo?.[groupIndex].tipo.includes(
                                    "O campo personalizado foi atualizado"
                                  ) && (
                                    <>
                                      <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        lg={this.getLgGrid(
                                          this.selecionadoTemDePara(
                                            eventos,
                                            groupIndex
                                          )
                                        )}
                                      >
                                        {console.log( this.state.customOrganizationFilterFields, 'customOrganizationFilterFields', evento.de)}
                                        <SimpleAutoComplete
                                          style={{ background: "white", fullWidth: true }}
                                          label="Campos personalizados"
                                          options={this.state.customOrganizationFilterFields}
                                          stateName="organizationFieldId"
                                          changeSelect={(_, value) => {
                                            this.atualizarEvento(groupIndex, "de", value?.id ?? null);
                                          }}
                                          selected={() => {
                                            return (
                                              this.state.customOrganizationFilterFields.find(
                                                (item) => item.id == evento.de
                                              ) ?? null
                                            );
                                          }}
                                        />
                                      </Grid>
                                      <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        lg={this.getLgGrid(
                                          this.selecionadoTemDePara(
                                            eventos,
                                            groupIndex
                                          )
                                        )}
                                      >
                                        <SimpleAutoComplete
                                          style={{ background: "white", fullWidth: true }}
                                          label="Campos personalizados"
                                          options={this.state.customOrganizationFilterFields}
                                          stateName="organizationFieldId"
                                          changeSelect={(_, value) => {
                                            this.atualizarEvento(groupIndex, "para", value?.id ?? null);
                                          }}
                                          selected={() => {
                                            return (
                                              this.state.customOrganizationFilterFields.find(
                                                (item) => item.id == evento.para
                                              ) ?? null
                                            );
                                          }}
                                        />
                                      </Grid>
                                    </>
                                  )}

                                {this.selecionadoTemDePara(
                                  eventos,
                                  groupIndex
                                ) &&
                                  !eventos?.grupo?.[groupIndex].tipo.includes(
                                    "Categoria foi atualizada"
                                  ) && (
                                    !eventos?.grupo?.[groupIndex].tipo.includes(
                                    "O campo personalizado foi atualizado"
                                  ) &&
                                    <>
                                      <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        lg={this.getLgGrid(
                                          this.selecionadoTemDePara(
                                            eventos,
                                            groupIndex
                                          )
                                        )}
                                      >
                                        {(() => {
                                          const tipo =
                                            eventos.grupo[groupIndex].tipo;
                                          switch (true) {
                                            case tipo.includes(
                                              "Responsável foi atualizado"
                                            ):
                                              return (
                                                <RealSimpleAutoComplete
                                                  style={{
                                                    background: "white",
                                                    fullWidth: true,
                                                  }}
                                                  label="Para"
                                                  options={this.addAnyToArray(
                                                    this.state
                                                      .assignedUserFilterList
                                                  )}
                                                  stateName=""
                                                  changeSelect={(
                                                    stateName,
                                                    value
                                                  ) => {
                                                    this.atualizarEvento(
                                                      groupIndex,
                                                      "para",
                                                      value?.id
                                                    );
                                                  }}
                                                  onFocus={
                                                    this.getFilterAssignedUser
                                                  }
                                                  loading={
                                                    this.state
                                                      .loadingAssignedUserFilter
                                                  }
                                                  selected={() => {
                                                    return (
                                                      this.addAnyToArray(
                                                        this.state
                                                          .assignedUserFilterList
                                                      ).find(
                                                        (item) =>
                                                          item.id == evento.para
                                                      ) ?? null
                                                    );
                                                  }}
                                                />
                                              );
                                            case tipo.includes(
                                              "O tipo foi alterado"
                                            ):
                                              return (
                                                <RealSimpleAutoComplete
                                                  style={{
                                                    background: "white",
                                                    fullWidth: true,
                                                  }}
                                                  label="Para"
                                                  options={this.addAnyToArray(
                                                    this.state.typeFilterList
                                                  )}
                                                  stateName=""
                                                  changeSelect={(
                                                    stateName,
                                                    value
                                                  ) => {
                                                    this.atualizarEvento(
                                                      groupIndex,
                                                      "para",
                                                      value?.id
                                                    );
                                                  }}
                                                  onFocus={this.getFilterType}
                                                  loading={
                                                    this.state.loadingTypeFilter
                                                  }
                                                  selected={() => {
                                                    return (
                                                      this.addAnyToArray(
                                                        this.state
                                                          .typeFilterList
                                                      ).find(
                                                        (item) =>
                                                          item.id == evento.para
                                                      ) ?? null
                                                    );
                                                  }}
                                                />
                                              );
                                            case tipo.includes(
                                              "O status foi alterado"
                                            ):
                                              return (
                                                <RealSimpleAutoComplete
                                                  style={{
                                                    background: "white",
                                                    fullWidth: true,
                                                  }}
                                                  label="Para"
                                                  options={this.addAnyToArray(
                                                    this.state.statusFilterList
                                                  )}
                                                  stateName=""
                                                  changeSelect={(
                                                    stateName,
                                                    value
                                                  ) => {
                                                    this.atualizarEvento(
                                                      groupIndex,
                                                      "para",
                                                      value?.id
                                                    );
                                                  }}
                                                  onFocus={this.getFilterStatus}
                                                  loading={
                                                    this.state
                                                      .loadingStatusFilter
                                                  }
                                                  selected={() => {
                                                    return (
                                                      this.addAnyToArray(
                                                        this.state
                                                          .statusFilterList
                                                      ).find(
                                                        (item) =>
                                                          item.id == evento.para
                                                      ) ?? null
                                                    );
                                                  }}
                                                />
                                              );
                                            case tipo.includes(
                                              "A prioridade foi alterada"
                                            ):
                                              return (
                                                <RealSimpleAutoComplete
                                                  style={{
                                                    background: "white",
                                                    fullWidth: true,
                                                  }}
                                                  label="Para"
                                                  options={this.addAnyToArray(
                                                    this.state
                                                      .priorityFilterList
                                                  )}
                                                  stateName=""
                                                  changeSelect={(
                                                    stateName,
                                                    value
                                                  ) => {
                                                    this.atualizarEvento(
                                                      groupIndex,
                                                      "para",
                                                      value?.id
                                                    );
                                                  }}
                                                  onFocus={
                                                    this.getFilterPriority
                                                  }
                                                  loading={
                                                    this.state
                                                      .loadingPriorityFilter
                                                  }
                                                  selected={() => {
                                                    return (
                                                      this.addAnyToArray(
                                                        this.state
                                                          .priorityFilterList
                                                      ).find(
                                                        (item) =>
                                                          item.id == evento.para
                                                      ) ?? null
                                                    );
                                                  }}
                                                />
                                              );
                                            default:
                                              return (
                                                <TextField
                                                  label="Para"
                                                  fullWidth
                                                  value={evento.para}
                                                  error={
                                                    this.errorsOnBlocosEventos(
                                                      errors,
                                                      groupIndex,
                                                      "para",
                                                      evento.para
                                                    ).error
                                                  }
                                                  helperText={
                                                    this.errorsOnBlocosEventos(
                                                      errors,
                                                      groupIndex,
                                                      "para",
                                                      evento.para
                                                    ).helperText
                                                  }
                                                  onChange={(e) =>
                                                    this.atualizarEvento(
                                                      groupIndex,
                                                      "para",
                                                      e.target.value
                                                    )
                                                  }
                                                  placeholder="Para"
                                                />
                                              );
                                          }
                                        })()}
                                      </Grid>
                                    </>
                                  )}
                              </Grid>
                            </Paper>
                          ))}

                          <Button
                            variant="outlined"
                            startIcon={<AddIcon />}
                            onClick={this.adicionarEvento}
                            color="primary"
                          >
                            Adicionar evento
                          </Button>
                        </>
                      )}
                    </AccordionDetails>
                  </Accordion>

                  {/* Filtros (Blocos de Condições) */}
                  <Accordion defaultExpanded sx={{ mb: 3 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="filtros-content"
                      id="filtros-header"
                    >
                      <Typography variant="h6">Filtros</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Configure blocos de filtros com condições. Você pode
                        usar operadores E/OU para combinar blocos e condições.
                      </Alert>

                      {blocosFiltro.map((bloco, blocoIndex) => (
                        <Paper
                          key={bloco.id}
                          variant="outlined"
                          sx={{ p: 2, mb: 3, bgcolor: "background.default" }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              mb: 2,
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              sx={{ fontWeight: "medium" }}
                            >
                              Bloco de Filtro {blocoIndex + 1}
                            </Typography>
                            {blocosFiltro?.length > 1 && (
                              <IconButton
                                size="small"
                                color="error"
                                onClick={() =>
                                  this.removerBlocoFiltro(bloco.id)
                                }
                                aria-label="Remover bloco de filtro"
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            )}
                          </Box>

                          {bloco?.grupos?.map((grupo, grupoIndex) => (
                            <Paper
                              key={grupo.id}
                              variant="outlined"
                              sx={{
                                p: 2,
                                mb: 2,
                                bgcolor: "background.paper",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  mb: 2,
                                }}
                              >
                                <Typography variant="subtitle2">
                                  Grupo {grupoIndex + 1}
                                </Typography>
                                {(bloco.grupos.length > 1 ||
                                  blocosFiltro.length > 1) && (
                                  <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() =>
                                      this.removerGrupo(bloco.id, grupo.id)
                                    }
                                    aria-label="Remover grupo"
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                )}
                              </Box>

                              {grupo?.condicoes.map(
                                (condicao, condicaoIndex) => {
                                  const selectedOperator = condicao.operatorList?.[0]
                                  const selectedField = selectedOperator?.field

                                  const field = blocosFiltro?.[blocoIndex]?.grupos?.[grupoIndex]?.condicoes?.[condicaoIndex]?.filtersFields ?? []

                                  const operatorName = condicao?.operatorList?.find(op => `operador_${op?.id}` === condicao.operador)?.name

                                  return (
                                  <Box key={condicaoIndex} sx={{ mb: 2 }}>
                                    {condicaoIndex > 0 && (
                                      <Box sx={{ my: 1 }}>
                                        <FormControl size="small">
                                          <Select
                                            value={
                                              grupo.operadorLogico.id ?? ""
                                            }
                                            onChange={(e) =>
                                              this.atualizarOperadorGrupo(
                                                bloco.id,
                                                grupo.id,
                                                e.target.value
                                              )
                                            }
                                            displayEmpty
                                          >
                                            {this.operadoresLogicos.map(
                                              (op) => (
                                                <MenuItem
                                                  key={op.id}
                                                  value={op.id}
                                                >
                                                  {op.name}
                                                </MenuItem>
                                              )
                                            )}
                                          </Select>
                                        </FormControl>
                                      </Box>
                                    )}

                                    <Grid
                                      container
                                      spacing={2}
                                      alignItems="center"
                                    >
                                      <Grid item xs={12} sm={3}>
                                        <FormControl
                                          fullWidth
                                          size="small"
                                          error={
                                            !!this.errorsOnBlocosFiltro(
                                              errors,
                                              blocoIndex,
                                              grupoIndex,
                                              condicaoIndex,
                                              condicao.campo
                                            ).error
                                          }
                                        >
                                           {/* Trocado label de campo para tipo */}
                                          <InputLabel>Tipo</InputLabel>
                                          <Tooltip title={condicao?.filtersFields?.[condicaoIndex]?.field} placement="top">
                                            <Select
                                              value={condicao?.campo ?? ""}
                                              label="Tipo"
                                              onChange={(e) =>
                                                this.atualizarCondicao(
                                                  bloco.id,
                                                  grupo.id,
                                                  condicaoIndex,
                                                  "campo",
                                                  e.target.value
                                                )
                                              }
                                            >
                                              {(fieldField ?? []).map((campo) => (
                                                <MenuItem
                                                  key={campo?.field}
                                                  value={`campo_${campo?.id}`}
                                                >
                                                  {campo?.field}
                                                </MenuItem>
                                              ))}
                                            </Select>
                                          </Tooltip>
                                        </FormControl>
                                      </Grid>

                                      <Grid item xs={12} sm={4}>
                                        <FormControl
                                          fullWidth
                                          size="small"
                                          error={
                                            !!this.errorsOnBlocosFiltro(
                                              errors,
                                              blocoIndex,
                                              grupoIndex,
                                              condicaoIndex,
                                              condicao.tipo
                                            ).error
                                          }
                                        >
                                           {/* Trocado label de tipo para campo */}
                                          <InputLabel>Campo</InputLabel>
                                          <Tooltip title={selectedField} placement="top">
                                            <Select
                                              value={condicao.tipo ?? ""}
                                              label="Campo"
                                              onChange={(e) =>
                                                this.atualizarCondicao(
                                                  bloco.id,
                                                  grupo.id,
                                                  condicaoIndex,
                                                  "tipo",
                                                  e.target.value
                                                )
                                              }
                                            >
                                              {(
                                                blocosFiltro?.[blocoIndex]
                                                  ?.grupos?.[grupoIndex]
                                                  ?.condicoes?.[condicaoIndex]
                                                  ?.filtersFields ?? []
                                              ).filter(c => c.condition != "Campo personalizado").map((tipo) => (
                                                
                                                <MenuItem
                                                  key={tipo.condition}
                                                  value={`tipo_${tipo?.conditioncriteriaid}`}
                                                >
                                                  {tipo.condition}
                                                </MenuItem>
                                              ))}
                                            </Select>
                                          </Tooltip>
                                        </FormControl>
                                      </Grid>

                                      <Grid item xs={12} sm={4}>
                                        <FormControl
                                          fullWidth
                                          size="small"
                                          error={
                                            !!this.errorsOnBlocosFiltro(
                                              errors,
                                              blocoIndex,
                                              grupoIndex,
                                              condicaoIndex,
                                              condicao.operador
                                            ).error
                                          }
                                        >
                                          <InputLabel>Operador</InputLabel>
                                          <Tooltip title={operatorName} placement="top">
                                            <Select
                                              value={condicao?.operador ?? ""}
                                              label="Operador"
                                              onChange={(e) =>
                                                this.atualizarCondicao(
                                                  bloco.id,
                                                  grupo.id,
                                                  condicaoIndex,
                                                  "operador",
                                                  e.target.value
                                                )
                                              }
                                            >
                                              {(
                                                blocosFiltro?.[blocoIndex]
                                                  ?.grupos?.[grupoIndex]
                                                  ?.condicoes?.[condicaoIndex]
                                                  ?.operatorList ?? []
                                              ).map((operador) => (
                                                <MenuItem
                                                  key={operador?.name}
                                                  value={`operador_${operador?.id}`}
                                                >
                                                  {operador?.name}
                                                </MenuItem>
                                              ))}
                                            </Select>
                                          </Tooltip>
                                        </FormControl>
                                      </Grid>

                                      <Grid item xs={12} sm={1}>
                                        <IconButton
                                          color="error"
                                          onClick={() =>
                                            this.removerCondicao(
                                              bloco.id,
                                              grupo.id,
                                              condicaoIndex
                                            )
                                          }
                                          aria-label="Remover condição"
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Grid>
                                      
                                      <Grid item xs={12} sm={12}>
                                        {(() => {
                                         const selectedOperator = condicao.operatorList?.[0]
                                          const selectedField = selectedOperator?.field

                                          switch (selectedField) {
                                            case "Modo Acompanhamento":
                                              return (
                                                <Tooltip
                                                  placement="top"
                                                  title={[{id: 1, name: "Privado", value: 1}, {id: 2, name: "Público", value: 0}]?.find(mode => mode.value === condicao.valor)?.name}
                                                >
                                                  <Stack>
                                                    <SimpleAutoComplete
                                                      selected={() => {
                                                        return (
                                                          [{id: 1, name: "Privado", value: 1}, {id: 2, name: "Público", value: 0}].find(
                                                            (item) =>
                                                              item.value ===
                                                              condicao.valor
                                                          ) ?? null
                                                        );
                                                      }}
                                                      size="small"
                                                      label="Modo Acompanhamento"
                                                      options={[{id: 1, name: "Privado", value: 1}, {id: 2, name: "Público", value: 0}]}
                                                      stateName=""
                                                      changeSelect={(
                                                        stateName,
                                                        value
                                                      ) => {
                                                        this.atualizarCondicao(
                                                          bloco.id,
                                                          grupo.id,
                                                          condicaoIndex,
                                                          "valor",
                                                          value?.value
                                                        );
                                                      }}
                                                    />
                                                  </Stack>
                                              </Tooltip>
                                            );
                                            case "Acompanhamento mais recente":
                                              return (
                                                <SimpleDatePicker 
                                                  label="Data do Acompanhamento"
                                                  stateName="openDate" 
                                                  changeDate={(
                                                    stateName,
                                                    value
                                                  ) => {
                                                    if(value && !isNaN(Date.parse(value))) {
                                                      const formatted = new Date(value).toISOString().split('T')[0];
                                                      this.atualizarCondicao(
                                                        bloco.id,
                                                        grupo.id,
                                                        condicaoIndex,
                                                        "valor",
                                                        formatted
                                                      );
                                                    }
                                                  }}
                                                  currentDate={condicao.valor}
                                                  fullWidth={true}
                                                />
                                              );
                                            case "Segmento da Organização":
                                              return (
                                                <Tooltip
                                                  placement="top"
                                                  title={this.state.segmentFilterList?.find(seg => seg.id === condicao.valor)?.name}
                                                >
                                                  <Stack>
                                                    <RealSimpleAutoComplete
                                                      style={{
                                                        background: "white",
                                                        fullWidth: true,
                                                      }}
                                                      label="Segmento"
                                                      options={
                                                        this.state
                                                          .segmentFilterList
                                                      }
                                                      stateName=""
                                                      changeSelect={(
                                                        stateName,
                                                        value
                                                      ) => {
                                                        this.atualizarCondicao(
                                                          bloco.id,
                                                          grupo.id,
                                                          condicaoIndex,
                                                          "valor",
                                                          value?.id
                                                        );
                                                      }}
                                                      onFocus={
                                                        this.getFilterSegment
                                                      }
                                                      size="small"
                                                      loading={
                                                        this.state
                                                          .loadingSegmentFilter
                                                      }
                                                      selected={() => {
                                                        return (
                                                          this.state.segmentFilterList.find(
                                                            (item) =>
                                                              item.id ===
                                                              condicao.valor
                                                          ) ?? null
                                                        );
                                                      }}
                                                    />
                                                  </Stack>
                                                </Tooltip>
                                              );
                                            case "Grupo da Organização":
                                              return (
                                                <Tooltip
                                                    placement="top"
                                                    title={this.state.groupFilterList?.find(filter => filter.id === condicao.valor)?.name}
                                                  >
                                                    <Stack>
                                                      <RealSimpleAutoComplete
                                                        style={{
                                                          background: "white",
                                                          fullWidth: true,
                                                        }}
                                                        label="Grupo"
                                                        options={
                                                          this.state
                                                            .groupFilterList
                                                        }
                                                        stateName=""
                                                        changeSelect={(
                                                          stateName,
                                                          value
                                                        ) => {
                                                          this.atualizarCondicao(
                                                            bloco.id,
                                                            grupo.id,
                                                            condicaoIndex,
                                                            "valor",
                                                            value?.id
                                                          );
                                                        }}
                                                        onFocus={
                                                          this.getFilterGroup
                                                        }
                                                        size="small"
                                                        loading={
                                                          this.state
                                                            .loadingGroupFilter
                                                        }
                                                        selected={() => {
                                                          return (
                                                            this.state.groupFilterList.find(
                                                              (item) =>
                                                                item.id ===
                                                                condicao.valor
                                                            ) ?? null
                                                          );
                                                        }}
                                                      />
                                                    </Stack>
                                                </Tooltip>
                                              );
                                            case "Formulário":
                                              return (
                                                <Tooltip
                                                  placement="top"
                                                  title={this.state.externalFormsFilterList?.find(filter => filter.id === condicao.valor)?.title}
                                                >
                                                  <Stack>
                                                    <RealSimpleAutoComplete
                                                      style={{
                                                        background: "white",
                                                        fullWidth: true,
                                                      }}
                                                      label="Formulário externo"
                                                      options={
                                                        this.state
                                                          .externalFormsFilterList
                                                      }
                                                      stateName=""
                                                      changeSelect={(
                                                        stateName,
                                                        value
                                                      ) => {
                                                        this.atualizarCondicao(
                                                          bloco.id,
                                                          grupo.id,
                                                          condicaoIndex,
                                                          "valor",
                                                          value?.id
                                                        );
                                                      }}
                                                      onFocus={
                                                        this.getFilterExternalForms
                                                      }
                                                      size="small"
                                                      loading={
                                                        this.state
                                                          .loadingExternalFormsFilter
                                                      }
                                                      selected={() => {
                                                        return (
                                                          this.state.externalFormsFilterList.find(
                                                            (item) =>
                                                              item.id ===
                                                              condicao.valor
                                                          ) ?? null
                                                        );
                                                      }}
                                                    />
                                                  </Stack>
                                                </Tooltip>
                                              );
                                            case "Categoria":
                                              return (
                                                <Tooltip
                                                  placement="top"
                                                  title={this.state.organizationsFilterList?.find(org => org.id === condicao.valor)?.name ?? ""}
                                                >
                                                  <Grid>
                                                    <RealSimpleAutoComplete
                                                      style={{
                                                        background: "white",
                                                        fullWidth: true
                                                      }}
                                                      label="Organização"
                                                      options={this.state.organizationsFilterList}
                                                      stateName="organizationId"
                                                      changeSelect={(stateName, value) =>
                                                        this.changeValuesPerFilter(stateName, value, "valor", condicaoIndex)
                                                      }
                                                      onFocus={
                                                        this
                                                          .getFilterOrganizations
                                                      }
                                                      size="small"
                                                      loading={
                                                        this.state
                                                          .loadingOrganizationFilter
                                                      }
                                                      selected={
                                                        this.state.filtersCalled?.valor?.organizationId?.[condicaoIndex] ?? null
                                                      }
                                                    />
                                                  </Grid>
                                                </Tooltip>
                                              );
                                            case "Responsável":
                                              return (
                                                <Tooltip
                                                  placement="top"
                                                  title={this.state.assignedUserFilterList?.find(filter => filter.id === condicao.valor)?.name ?? ""}
                                                >
                                                  <Stack>
                                                    <RealSimpleAutoComplete
                                                      style={{
                                                        background: "white",
                                                        fullWidth: true,
                                                      }}
                                                      label="Responsável"
                                                      options={
                                                        this.state
                                                          .assignedUserFilterList
                                                      }
                                                      stateName=""
                                                      changeSelect={(
                                                        stateName,
                                                        value
                                                      ) => {
                                                        this.atualizarCondicao(
                                                          bloco.id,
                                                          grupo.id,
                                                          condicaoIndex,
                                                          "valor",
                                                          value?.id
                                                        );
                                                      }}
                                                      onFocus={
                                                        this.getFilterAssignedUser
                                                      }
                                                      size="small"
                                                      loading={
                                                        this.state
                                                          .loadingAssignedUserFilter
                                                      }
                                                      selected={() => {
                                                        return (
                                                          this.state.assignedUserFilterList.find(
                                                            (item) =>
                                                              item.id ===
                                                              condicao.valor
                                                          ) ?? null
                                                        );
                                                      }}
                                                    />
                                                  </Stack>
                                                </Tooltip>
                                              );
                                            case "Organização":
                                              return (
                                                <Tooltip
                                                  placement="top"
                                                  title={this.state.organizationsFilterList?.find(org => org.id === condicao.valor)?.name ?? ""}
                                                >
                                                  <Stack>
                                                    <RealSimpleAutoComplete
                                                      style={{
                                                        background: "white",
                                                        fullWidth: true,
                                                      }}
                                                      label="Organização"
                                                      options={
                                                        this.state
                                                          .organizationsFilterList
                                                      }
                                                      stateName=""
                                                      changeSelect={(
                                                        stateName,
                                                        value
                                                      ) => {
                                                        this.atualizarCondicao(
                                                          bloco.id,
                                                          grupo.id,
                                                          condicaoIndex,
                                                          "valor",
                                                          value?.id
                                                        );
                                                      }}
                                                      onFocus={
                                                        this.getFilterOrganizations
                                                      }
                                                      size="small"
                                                      loading={
                                                        this.state
                                                          .loadingOrganizationFilter
                                                      }
                                                      selected={() => {
                                                        return (
                                                          this.state.organizationsFilterList.find(
                                                            (item) =>
                                                              item.id ===
                                                              condicao.valor
                                                          ) ?? null
                                                        );
                                                      }}
                                                    />
                                                  </Stack>
                                                </Tooltip>
                                              );
                                            case "Tipo":
                                              return (
                                                <Tooltip
                                                  placement="top"
                                                  title={this.state.typeFilterList?.find(filter => filter.id === condicao.valor)?.name ?? ""}
                                                >
                                                  <Stack>
                                                    <RealSimpleAutoComplete
                                                      style={{
                                                        background: "white",
                                                        fullWidth: true,
                                                      }}
                                                      label="Tipo do Chamado"
                                                      options={
                                                        this.state.typeFilterList
                                                      }
                                                      stateName=""
                                                      changeSelect={(
                                                        stateName,
                                                        value
                                                      ) => {
                                                        this.atualizarCondicao(
                                                          bloco.id,
                                                          grupo.id,
                                                          condicaoIndex,
                                                          "valor",
                                                          value?.id
                                                        );
                                                      }}
                                                      onFocus={this.getFilterType}
                                                      size="small"
                                                      loading={
                                                        this.state.loadingTypeFilter
                                                      }
                                                      selected={() => {
                                                        return (
                                                          this.state.typeFilterList.find(
                                                            (item) =>
                                                              item.id ===
                                                              condicao.valor
                                                          ) ?? null
                                                        );
                                                      }}
                                                    />
                                                  </Stack>
                                                </Tooltip>
                                              );
                                            case "Grupo":
                                              return (
                                                <Tooltip
                                                  placement="top"
                                                  title={this.state.groupFilterList?.find(filter => filter.id === condicao.valor)?.name ?? ""}
                                                >
                                                  <Stack>
                                                    <RealSimpleAutoComplete
                                                      style={{
                                                        background: "white",
                                                        fullWidth: true,
                                                      }}
                                                      label="Grupo"
                                                      options={
                                                        this.state.groupFilterList
                                                      }
                                                      stateName=""
                                                      changeSelect={(
                                                        stateName,
                                                        value
                                                      ) => {
                                                        this.atualizarCondicao(
                                                          bloco.id,
                                                          grupo.id,
                                                          condicaoIndex,
                                                          "valor",
                                                          value?.id
                                                        );
                                                      }}
                                                      onFocus={this.getFilterGroup}
                                                      size="small"
                                                      loading={
                                                        this.state
                                                          .loadingGroupFilter
                                                      }
                                                      selected={() => {
                                                        return (
                                                          this.state.groupFilterList.find(
                                                            (item) =>
                                                              item.id ===
                                                              condicao.valor
                                                          ) ?? null
                                                        );
                                                      }}
                                                    />
                                                  </Stack>
                                                </Tooltip>
                                              );
                                            case "Origem":
                                              return (
                                                <Tooltip
                                                  placement="top"
                                                  title={this.state.originFilterList?.find(filter => filter.id === condicao.valor)?.name ?? ""}
                                                >
                                                  <Stack>
                                                      <RealSimpleAutoComplete
                                                        style={{
                                                          background: "white",
                                                          fullWidth: true,
                                                        }}
                                                        label="Origem"
                                                        options={
                                                          this.state.originFilterList
                                                        }
                                                        stateName=""
                                                        changeSelect={(
                                                          stateName,
                                                          value
                                                        ) => {
                                                          this.atualizarCondicao(
                                                            bloco.id,
                                                            grupo.id,
                                                            condicaoIndex,
                                                            "valor",
                                                            value?.id
                                                          );
                                                        }}
                                                        onFocus={this.getFilterOrigin}
                                                        size="small"
                                                        loading={
                                                          this.state
                                                            .loadingOriginFilter
                                                        }
                                                        selected={() => {
                                                          return (
                                                            this.state.originFilterList.find(
                                                              (item) =>
                                                                item.id ===
                                                                condicao.valor
                                                            ) ?? null
                                                          );
                                                        }}
                                                      />
                                                  </Stack>
                                                </Tooltip>
                                              );
                                            case "Status":
                                              return (
                                                <Tooltip
                                                  placement="top"
                                                  title={this.state.statusFilterList?.find(filter => filter.id === condicao.valor)?.name ?? ""}
                                                >
                                                  <Stack>
                                                    <RealSimpleAutoComplete
                                                      style={{
                                                        background: "white",
                                                        fullWidth: true,
                                                      }}
                                                      label="Status"
                                                      options={
                                                        this.state.statusFilterList
                                                      }
                                                      stateName=""
                                                      changeSelect={(
                                                        stateName,
                                                        value
                                                      ) => {
                                                        this.atualizarCondicao(
                                                          bloco.id,
                                                          grupo.id,
                                                          condicaoIndex,
                                                          "valor",
                                                          value?.id
                                                        );
                                                      }}
                                                      onFocus={this.getFilterStatus}
                                                      size="small"
                                                      loading={
                                                        this.state
                                                          .loadingStatusFilter
                                                      }
                                                      selected={() => {
                                                        return (
                                                          this.state.statusFilterList.find(
                                                            (item) =>
                                                              item.id ===
                                                              condicao.valor
                                                          ) ?? null
                                                        );
                                                      }}
                                                    />
                                                  </Stack>
                                                </Tooltip>
                                              );
                                            case "Prioridade":
                                              return (
                                                <Tooltip
                                                  placement="top"
                                                  title={this.state.priorityFilterList?.find(filter => filter.id === condicao.valor)?.name ?? ""}
                                                >
                                                  <Stack>
                                                    <RealSimpleAutoComplete
                                                      style={{
                                                        background: "white",
                                                        fullWidth: true,
                                                      }}
                                                      label="Prioridade"
                                                      options={
                                                        this.state
                                                          .priorityFilterList
                                                      }
                                                      stateName=""
                                                      changeSelect={(
                                                        stateName,
                                                        value
                                                      ) => {
                                                        this.atualizarCondicao(
                                                          bloco.id,
                                                          grupo.id,
                                                          condicaoIndex,
                                                          "valor",
                                                          value?.id
                                                        );
                                                      }}
                                                      onFocus={
                                                        this.getFilterPriority
                                                      }
                                                      size="small"
                                                      loading={
                                                        this.state
                                                          .loadingPriorityFilter
                                                      }
                                                      selected={() => {
                                                        return (
                                                          this.state.priorityFilterList.find(
                                                            (item) =>
                                                              item.id ===
                                                              condicao.valor
                                                          ) ?? null
                                                        );
                                                      }}
                                                    />
                                                  </Stack>
                                                </Tooltip>
                                              );
                                              case "Tag":
                                                return(
                                                  <Stack spacing={1}>
                                                  <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Adicionar tag"
                                                    placeholder="Digite uma tag e pressione Enter"
                                                    value={condicao.inputFilterTagValue}
                                                    onChange={(e) => {
                                                      this.atualizarCondicao(
                                                        bloco.id,
                                                        grupo.id,
                                                        condicaoIndex,
                                                        "inputFilterTagValue",
                                                        e.target.value
                                                      );
                                                    }}
                                                    onKeyDown={(e) =>
                                                      this.handleFilterTagInputKeyDown(
                                                        e,
                                                        condicao,
                                                        bloco.id,
                                                        grupo.id,
                                                        condicaoIndex
                                                      )}
                                                      error={
                                                        !!this.errorsOnBlocosFiltro(
                                                          errors,
                                                          blocoIndex,
                                                          grupoIndex,
                                                          condicaoIndex,
                                                          condicao.valor
                                                        ).error || this.state.hasDuplicates
                                                      }
                                                      />
                                                      {(condicao?.valor?.split(",")?.filter((ac) => ac) ?? []).length > 0 && (
                                                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                                        {(condicao?.valor?.split(",")?.filter((ac) => ac) ?? [])
                                                          .map((tag, index) => (
                                                            <Chip
                                                            key={index}
                                                            label={tag}
                                                            onDelete={() => 
                                                              this.handleDeleteTagFilterTag(
                                                                tag,
                                                                condicao?.valor,
                                                                bloco.id,
                                                                grupo.id,
                                                                condicaoIndex
                                                              )}
                                                              color="primary"
                                                              variant="outlined"
                                                              />
                                                            ))}
                                                            </Box>
                                                          )}
                                                          </Stack>
                                                );
                                              default:
                                                if (this.filtroCampoQueNaoPrecisaDoValor(condicao)) {
                                                  return null;
                                                }
                                                
                                                const multipleValueFields = ["operador_3", "operador_4", "operador_7", "operador_8", "operador_13", "operador_14"];
                                                
                                                if (multipleValueFields.includes(condicao.operador)) {
                                                  return (
                                                    <Stack spacing={1}>
                                                      <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Adicionar valores"
                                                        placeholder="Digite um valor e pressione Enter"
                                                        value={condicao.inputFilterTagValue}
                                                        onChange={(e) => {
                                                          this.atualizarCondicao(
                                                            bloco.id,
                                                            grupo.id,
                                                            condicaoIndex,
                                                            "inputFilterTagValue",
                                                            e.target.value
                                                          )
                                                        }}
                                                        onKeyDown={(e) =>
                                                          this.handleFilterTagInputKeyDown(
                                                            e,
                                                            condicao,
                                                            bloco.id,
                                                            grupo.id,
                                                            condicaoIndex
                                                          )}
                                                        onBlur={(e) => {
                                                          this.handleOnBlurAddValues(e, bloco, grupo, condicaoIndex);
                                                        }}
                                                        error={
                                                          !!this.errorsOnBlocosFiltro(
                                                            errors,
                                                            blocoIndex,
                                                            grupoIndex,
                                                            condicaoIndex,
                                                            condicao.valor
                                                          ).error || this.state.hasDuplicates
                                                        }
                                                      />
                                                    </Stack>
                                                  )
                                                }
                                                                                            
                                                return (
                                                  <TextField
                                                    size="small"
                                                    label="Valor"
                                                    value={condicao.valor}
                                                    error={
                                                      !!this.errorsOnBlocosFiltro(
                                                        errors,
                                                        blocoIndex,
                                                        grupoIndex,
                                                        condicaoIndex,
                                                        condicao.valor
                                                      ).error || this.state.hasDuplicates
                                                    }
                                                    onChange={(e) =>
                                                      this.atualizarCondicao(
                                                        bloco.id,
                                                        grupo.id,
                                                        condicaoIndex,
                                                        "valor",
                                                        e.target.value
                                                      )
                                                    }
                                                    placeholder="Valor"
                                                  />
                                                );
                                          }
                                        })()}
                                      </Grid>

                                      <Grid item xs={12} sm={12}>
                                        {(() => {
                                          const selectedOperator = condicao.operatorList?.[0]
                                          const selectedField = selectedOperator?.field

                                          switch (selectedField) {
                                            case "Categoria":
                                              return (
                                                <Tooltip
                                                  placement="top"
                                                  title={this.state.categoriesFilterList?.valor?.[condicaoIndex]?.find(org => org.id === condicao.valor)?.name ?? ""}
                                                >
                                                  <Grid>
                                                    <RealSimpleAutoComplete
                                                      style={{
                                                        background: "white",
                                                        fullWidth: true,
                                                        marginTop: 5,
                                                      }}
                                                      label="Categoria"
                                                      options={
                                                        this.state.categoriesFilterList?.valor?.[condicaoIndex] ?? []
                                                      }
                                                      stateName=""
                                                      changeSelect={(_, value) => {
                                                        this.atualizarCondicao(
                                                          bloco.id,
                                                          grupo.id,
                                                          condicaoIndex,
                                                          "valor",
                                                          value?.id
                                                        );
                                                      }}
                                                      onFocus={() => {
                                                        const orgId = this.state.filtersCalled?.valor?.organizationId?.[condicaoIndex] ?? null;
                                                        this.getFilterCategoriesByOrganization(orgId, "valor", condicaoIndex);
                                                      }}
                                                      size="small"
                                                      loading={
                                                        this.state
                                                          .loadingCategoryFilter
                                                      }
                                                      selected={
                                                        this.addAnyToArray(
                                                          this.state.categoriesFilterList?.valor?.[condicaoIndex] ?? []
                                                        ).find(item => item.id == condicao.valor) ?? null
                                                      }
                                                    />
                                                  </Grid>
                                                </Tooltip>
                                              );
                                            default:
                                              const multipleValueFields = ["operador_3", "operador_4", "operador_7", "operador_8", "operador_13", "operador_14"];
                                              
                                              if (multipleValueFields.includes(condicao.operador)) {
                                                return (
                                                  <Stack spacing={1}>
                                                    {(condicao?.valor?.split(",")?.filter((ac) => ac) ?? []).length > 0 && (
                                                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                                        {(condicao?.valor?.split(",")?.filter((ac) => ac) ?? [])
                                                          .map((tag, index) => (
                                                            <Chip
                                                              key={index}
                                                              label={tag}
                                                              onDelete={() =>
                                                                this.handleDeleteTagFilterTag(
                                                                  tag,
                                                                  condicao?.valor,
                                                                  bloco.id,
                                                                  grupo.id,
                                                                  condicaoIndex
                                                                )}
                                                              color="primary"
                                                              variant="outlined"
                                                            />
                                                          ))}
                                                      </Box>
                                                    )}
                                                  </Stack>
                                                )
                                              }

                                              return <></>;
                                          }
                                        })()}
                                      </Grid>
                                    </Grid>

                                    {this.errorsOnBlocosFiltro(
                                      errors,
                                      blocoIndex,
                                      grupoIndex,
                                      condicaoIndex,
                                      null
                                    ).error && (
                                      <FormHelperText error>
                                        {
                                          this.errorsOnBlocosFiltro(
                                            errors,
                                            blocoIndex,
                                            grupoIndex,
                                            condicaoIndex,
                                            null
                                          ).helperText
                                        }
                                      </FormHelperText>
                                    )}
                                  </Box>
                                )}
                              )}

                              {this.errorsOnBlocosFiltro(
                                  errors,
                                  blocoIndex,
                                  grupoIndex,
                                  null,
                                  null
                                )?.hasDuplicateFilter && (
                                <FormHelperText error sx={{ pt: 1}}>
                                  {this.errorsOnBlocosFiltro(
                                    errors,
                                    blocoIndex,
                                    grupoIndex,
                                    null,
                                    null
                                  )?.hasDuplicateFilter}
                                </FormHelperText>
                              )}

                              <Button
                                startIcon={<AddIcon />}
                                onClick={() =>
                                  this.adicionarCondicao(bloco.id, grupo.id)
                                }
                                size="small"
                                color="primary"
                                sx={{ mt: 1 }}
                              >
                                Adicionar condição
                              </Button>
                            </Paper>
                          ))}

                          {blocoIndex < blocosFiltro.length - 1 && (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                my: 2,
                              }}
                            >
                              <FormControl sx={{ minWidth: 120 }}>
                                <InputLabel>Operador</InputLabel>
                                <Select
                                  value={bloco.operadorLogico.id ?? ""}
                                  label="Operador"
                                  onChange={(e) =>
                                    this.atualizarOperadorBloco(
                                      bloco.id,
                                      e.target.value
                                    )
                                  }
                                >
                                  {this.operadoresLogicos.map((op) => (
                                    <MenuItem key={op.id} value={op.id}>
                                      {op.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Box>
                          )}
                        </Paper>
                      ))}

                      <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={this.adicionarBlocoFiltro}
                        color="primary"
                      >
                        Adicionar bloco de filtro
                      </Button>
                    </AccordionDetails>
                  </Accordion>

                  {/* Ações */}
                  <Accordion defaultExpanded sx={{ mb: 3 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="acoes-content"
                      id="acoes-header"
                    >
                      <Typography variant="h6">Ações</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Alert severity="success" sx={{ mb: 2 }}>
                        As seguintes ações serão executadas quando as condições
                        forem atendidas.
                      </Alert>

                      {errors?.customAcoes && errors?.customAcoes.length > 0 && (
                        <FormHelperText error sx={{ pb: 2, pt: 2 }}>
                          {errors.customAcoes?.map((msg, i) => (
                            <span key={i}>
                              {msg}
                              <br />
                            </span>
                          ))}
                        </FormHelperText>
                      )}

                      {acoes.map((acao, index) => (
                        <Paper
                          key={index}
                          variant="outlined"
                          sx={{ p: 2, mb: 2 }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              mb: 2,
                            }}
                          >
                            <Typography variant="subtitle2">
                              Ação {index + 1}
                            </Typography>
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => this.removerAcao(index)}
                              aria-label="Remover ação"
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Box>

                          <Grid container spacing={2} alignItems={"center"}>
                            <Grid item xs={12} sm={6}>
                              <FormControl
                                fullWidth
                                error={!!errors.acoes?.[index]?.tipo}
                              >
                                <InputLabel>Tipo de Ação</InputLabel>
                                <Select
                                  value={acao.tipo ?? ""}
                                  label="Tipo de Ação"
                                  error={!!errors.acoes?.[index]?.tipo}
                                  onChange={(e) => {
                                    this.atualizarAcaoTipo(
                                      index,
                                      actionsFields,
                                      e.target.value
                                    );
                                    this.atualizarAcao(index, "valor", null);
                                  }}
                                >
                                  {this.cleanListFromAny(actionsFields, "id", acoes, "tipo", index, false)
                                  .map((tipo) => (
                                    <MenuItem key={tipo.label} value={tipo.id}>
                                      {tipo?.name}
                                    </MenuItem>
                                  ))}
                                </Select>

                                {errors.acoes?.[index]?.tipo && (
                                  <FormHelperText error>
                                    {errors.acoes[index].tipo}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Grid>
                            {acao.tipo &&
                              this.renderInputsByFieldtype(acao, index)}
                          </Grid>
                        </Paper>
                      ))}

                      <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={this.adicionarAcao}
                        color="primary"
                      >
                        Adicionar ação
                      </Button>
                    </AccordionDetails>
                  </Accordion>

                  {/* Botões de ação */}
                  <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={this.salvarAutomacao}
                      color="primary"
                    >
                      Salvar Automação
                    </Button>
                  </Stack>
                </Box>
              </form>
            </div>
            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}
            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}

AutomationEdit.propTypes = { classes: PropTypes.object.isRequired };

const mapStateToProps = (state) => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  automations: state.automations,
});

export default injectIntl(
  connect(mapStateToProps)(withStyles(Styles)(AutomationEdit))
);